<template>
  <div v-if="viewGC">
    <v-row>
      <v-col cols="12">
        <ButtonComp @click="ConfirmVolverShow()" text-button="Volver" class-color="red" normal-button
          icon-but="fas fa-arrow-alt-circle-left" />
      </v-col>
      <v-col cols="12" sm="3" md="2">
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-btn class="mb-1 mr-2" color="#1C68E3" dark small block @click="LoadMenu(true, `template`)">Ver
                  Plantillas</v-btn>
                <v-btn class="mb-1 btn_green" dark small block @click="LoadMenu(true, `resource`)">Recursos</v-btn>

                <template v-if="activateTemplate">
                  <v-text-field label="Buscar" v-model="filtro.search" @click:append="Search(filtro.search, 'template')"
                    @input="Search(filtro.search, 'template')" append-icon="fa-search" single-line hide-details
                    class="mb-1">
                  </v-text-field>

                  <v-select label="Nivel" v-model="filtro.id_nivel" small :items="listNivel" item-value="id"
                    item-text="desc_nivel" @change="EventNivel(filtro)">
                  </v-select>

                  <v-select label="Área" v-model="filtro.id_area" :items="listArea" item-value="id"
                    item-text="desc_area" @change="GetTemplate()">
                  </v-select>

                  <div class="scroll" v-scroll.self="handleScroll">
                    <v-badge color="transparent" overlap left v-for="(template, index) of listTemplate"
                      :class="showMenu[template.id] ? 'templeft' : ''" :key="`template-${index}`">
                      <template v-slot:badge>
                        <v-menu dark content-class="elevation-1" v-model="showMenu[template.id]" :position-x="x"
                          :position-y="y" offset-y>
                          <v-list dense>
                            <v-list-item-group>
                              <v-list-item @click="EliminarPlantilla(template.id, index)">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <v-icon small left>fa-minus</v-icon>Eliminar
                                    plantilla
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-menu>

                        <v-btn style="position: absolute" color="success" dark fab x-small
                          @click="editarPlantilla(template)">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <v-img width="177" class="ig-img" :src="`${URL_SPACE + template.uri}${cacheDinamica}`"
                        :lazy-src="`@/assets/placeholder-diapo.svg`" @click="
                          CargarTemplate(template);
                        showMenu[template.id] = false;
                        " @click.right.prevent="menuTemplate($event, template)">
                        <template v-slot:placeholder>
                          <div class="d-flex align-center justify-center fill-height">
                            <v-progress-circular color="grey-lighten-4" indeterminate></v-progress-circular>
                          </div>
                        </template>
                      </v-img>
                    </v-badge>
                  </div>
                  <!-- <v-btn color="warning" dark fab x-small @click="editarPlantilla(template)">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn> @click="CargarTemplate(template)" ?nocache=${new Date().getTime()} -->
                  <v-btn class="btn_block_style2" small dark block @click="crearPlantilla()">Crear plantilla</v-btn>
                </template>

                <template v-if="activateResource">
                  <v-text-field label="Buscar" v-model="filtro.search" @click:append="Search(filtro.search, 'resource')"
                    @input="Search(filtro.search, 'resource')" append-icon="fa-search" single-line hide-details
                    class="mb-1">
                  </v-text-field>

                  <v-select label="Tipo de recurso" v-model="filtro.id_tipo_recurso" :items="listTipoRecurso"
                    item-value="id" item-text="descripcion" @change="changeResource(filtro)">
                  </v-select>

                  <v-select label="Acceso" v-model="filtro.id_acceso" :items="listAcceso" item-value="id"
                    item-text="descripcion" @change="changeResource(filtro)">
                  </v-select>

                  <v-select label="Nivel" v-model="filtro.id_nivel" small :items="listNivel" item-value="id"
                    item-text="desc_nivel" @change="EventNivel(filtro)">
                  </v-select>

                  <v-select label="Área" v-model="filtro.id_area" :items="listArea" item-value="id"
                    item-text="desc_area" @change="changeResource(filtro)">
                  </v-select>

                  <v-btn class="btn_block_style2" small dark block @click="LoadResource()">Subir Recursos</v-btn>
                  <br />
                  <v-row style="max-height: 40vh" class="overflow-y-auto" ref="scrollFetch" @scroll="checkScrollMetodo">
                    <v-col cols="12" md="6" v-for="(item, index) of listResourse" :key="index">
                      <!-- RECURSO IMAGEN -->
                      <v-card v-if="item.id_tipo_recurso.trim() == 'img'" class="cardMiniatura">
                        <i @click="UpdateFile(item)" class="fas fa-edit fa-1x iconoUpdateBadge"
                          style="color: #ffbc00"></i>
                        <i @click="DeleteFile(item)" class="fas fa-times-circle fa-1x iconoEliminarBadge"
                          style="color: #c10606"></i>
                        <v-img contain aspect-ratio="1" max-width="200" max-height="150"
                          class="white--text align-end imagen ig-img" :src="URL_SPACE + item.file_link"
                          lazy-src="@/assets/placeholder_img.svg" @click="LoadImage(item.file_link)">
                          <template v-slot:placeholder>
                            <div class="d-flex align-center justify-center fill-height">
                              <v-progress-circular color="grey" indeterminate></v-progress-circular>
                            </div>
                          </template>
                        </v-img>
                        <div style="
                            height: 30px;
                            overflow: hidden;
                            line-height: 12px;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            flex-wrap: nowrap;
                          " class="contMiniatura text-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span class="font-black" style="font-size: 10px" v-bind="attrs" v-on="on">{{
                                item.file_desc }}</span>
                            </template>
                            <span>{{ item.file_desc }}</span>
                          </v-tooltip>
                        </div>
                      </v-card>
                      <!-- RECURSO DOCUMENTO -->
                      <v-card v-if="item.id_tipo_recurso.trim() == 'doc'" class="cardMiniatura text-align: center mt-2">
                        <i @click="UpdateFile(item)" class="fas fa-edit fa-1x iconoUpdateBadge"
                          style="color: #ffbc00"></i>
                        <i @click="DeleteFile(item)" class="fas fa-times-circle fa-1x iconoEliminarBadge"
                          style="color: #c10606"></i>
                        <i @click="AddDocumento(item)" v-if="
                          item.file_ext == '.doc' || item.file_ext == '.docx'
                        " class="far fa-file-word fa-3x pointing"></i>
                        <i @click="AddDocumento(item)" v-if="
                          item.file_ext == '.xls' || item.file_ext == '.xlsx'
                        " class="far fa-file-excel fa-3x pointing"></i>
                        <i @click="AddDocumento(item)" v-if="item.file_ext == '.pdf'"
                          class="far fa-file-pdf fa-3x pointing"></i>
                        <div class="contMiniatura text-center">
                          <span class="font-black" style="font-size: 10px">{{
                            item.file_desc
                          }}</span>
                        </div>
                      </v-card>
                      <!-- RECURSO VIDEO -->
                      <v-card v-if="item.id_tipo_recurso.trim() == 'vid'" class="cardMiniatura text-align: center mt-2">
                        <i @click="UpdateFile(item)" class="fas fa-edit fa-1x iconoUpdateBadge"
                          style="color: #ffbc00"></i>
                        <i @click="DeleteFile(item, index)" class="fas fa-times-circle fa-1x iconoEliminarBadge"
                          style="color: #c10606"></i>
                        <v-btn :loading="loadingVideo.includes(item.id)" :disabled="loadingVideo.includes(item.id)"
                          :ripple="false" x-large icon @click="LoadVideo(item.id, item.file_link)">
                          <v-icon>fab fa-youtube</v-icon>
                        </v-btn>
                        <div class="contMiniatura text-center">
                          <span class="font-black" style="font-size: 10px">{{
                            item.file_desc
                          }}</span>
                        </div>
                      </v-card>
                      <!-- RECURSO AUDIO -->
                      <v-card v-if="item.id_tipo_recurso.trim() == 'aud'" class="cardMiniatura text-align: center mt-2">
                        <i @click="UpdateFile(item)" class="fas fa-edit fa-1x iconoUpdateBadge"
                          style="color: #ffbc00"></i>
                        <i @click="DeleteFile(item)" class="fas fa-times-circle fa-1x iconoEliminarBadge"
                          style="color: #c10606"></i>
                        <i @click="LoadAudio(item.file_link)" class="fas fa-music fa-3x pointing"></i>
                        <div class="contMiniatura text-center">
                          <span class="font-black" style="font-size: 10px">{{
                            item.file_desc
                          }}</span>
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12">
                      <div class="d-flex justify-center">
                        <v-btn block text x-small @click="(paginaActual += 1), GetResource()"
                          v-if="listResourse.length">Ver Más ...
                        </v-btn>
                      </div>
                      <div class="grey--text mb-2 text-center" v-if="messageVacio">
                        No existen recursos
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="9" md="10">
        <v-card outlined>
          <v-card-text>
            <v-row class="d-flex justify-end py-0 my-0 mx-1">
              <!-- ELIMINAR LA CONDICION CUANDO EL BTN SE ENCUENTRE LISTO -->
              <template v-if="true">
                <ButtonComp @click="LoadImportDoc()" text-button="Importar" class-color="success" />
              </template>
              <v-spacer></v-spacer>
              <ButtonComp @click="AddNewDiapositiva(null, null, null)" text-button="Nueva diapositiva"
                iconBut="fas fa-plus" class-color="warning" />
              <ButtonComp @click="ChangeDiapositiva(false, false, true, false)" :loading="guardando"
                text-button="Guardar" icon-but="fas fa-save" class="mx-2" />
            </v-row>

            <v-row class="py-2">
              <v-col cols="12" class="elevation-2">
                <v-toolbar dense small class="elevation-0">
                  <v-overflow-btn v-if="
                    objectSelected != null &&
                    objectSelected.data.type == 'texto'
                  " :items="textConfig.fonts" item-value="value" item-text="name" :value="fontFamily" small dense
                    :label="fontFamily" v-model="fontFamily" hide-details class="pa-0" @change="RenderFontFamily()">
                  </v-overflow-btn>
                  <!-- <v-overflow-btn :value="defaultValue"></v-overflow-btn> -->
                  <template v-if="
                    objectSelected != null &&
                    objectSelected.data.type == 'texto'
                  ">
                    <v-responsive class="mx-2 pt-5" max-width="50">
                      <v-text-field type="number" v-if="
                        objectSelected != null &&
                        objectSelected.data.type == 'texto'
                      " min="10" max="99" oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                        placeholder="Tamaño de Fuente" v-model.number="fontSize"
                        @input="RenderFontSize()"></v-text-field>
                    </v-responsive>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="mx-2" small dense text :style="swatchStyle" id="menu-ct-activator" v-if="
                          objectSelected &&
                          objectSelected.data.type == 'texto'
                        ">
                          <v-img src="@/assets/iconos/font.jpg"></v-img>
                        </v-btn>
                      </template>
                      <span>Color de la fuente</span>
                    </v-tooltip>

                    <v-menu activator="#menu-ct-activator" top nudge-bottom="105" nudge-left="16"
                      :close-on-content-click="false">
                      <v-card>
                        <v-card-text class="pa-0">
                          <v-color-picker v-model="objectSelected.data.color" mode="hexa" @input="RenderFill()" />
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small id="menu-cbt-activator">
                          <v-icon small>fas fa-fill</v-icon>
                        </v-btn>
                      </template>
                      <span>Color de fondo de la fuente</span>
                    </v-tooltip>

                    <v-menu activator="#menu-cbt-activator" top nudge-bottom="105" nudge-left="16"
                      :close-on-content-click="false">
                      <v-card>
                        <v-card-text class="pa-0">
                          <v-color-picker v-model="objectSelected.data.backgroundColor" mode="hexa" show-swatches
                            :swatches="swatches" @input="RenderBackGroundColorText()" />
                          <!-- <v-color-picker  v-model="objectSelected.data.backgroundColor" mode="hexa"  @input="RenderBackGroundColorText()"/> -->
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="changeFontWeight()" small dense text cols="2" :color="objectSelected.fontWeight == 'normal'
                          ? 'default'
                          : 'primary'
                          ">
                          <v-icon large>mdi-format-bold</v-icon>
                        </v-btn>
                      </template>
                      <span>Negrita</span>
                    </v-tooltip>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="underLineText()" small dense text cols="2">
                          <v-icon large>mdi-format-underline</v-icon>
                        </v-btn>
                      </template>
                      <span>Subrayar</span>
                    </v-tooltip>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="changeFontStyle()" small dense text :color="objectSelected.fontStyle == 'normal'
                          ? 'default'
                          : 'primary'
                          ">
                          <v-icon large>mdi-format-italic</v-icon>
                        </v-btn>
                      </template>
                      <span>Cursiva</span>
                    </v-tooltip>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="changeFontVariant()" small dense text :color="objectSelected.fontVariant == 'lowercase'
                          ? 'default'
                          : 'primary'
                          ">
                          <v-icon>fa-solid fa-font</v-icon>
                        </v-btn>
                      </template>
                      <span>Alternar mayúsculas</span>
                    </v-tooltip>

                    <v-btn-toggle class="mr-2" small dense v-model="objectSelected.textAlign" mandatory
                      @change="Render()">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" value="left">
                            <v-icon>fa-solid fa-align-left</v-icon>
                          </v-btn>
                        </template>
                        <span>Alinear a la izquierda</span>
                      </v-tooltip>

                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" value="center">
                            <v-icon>fa-solid fa-align-center</v-icon>
                          </v-btn>
                        </template>
                        <span>Centrar</span>
                      </v-tooltip>

                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" value="right">
                            <v-icon>fa-solid fa-align-right</v-icon>
                          </v-btn>
                        </template>
                        <span>Alinear a la derecha</span>
                      </v-tooltip>

                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" value="justify-left">
                            <v-icon>fa-solid fa-align-justify</v-icon>
                          </v-btn>
                        </template>
                        <span>Justificar</span>
                      </v-tooltip>
                    </v-btn-toggle>
                  </template>

                  <v-tooltip bottom color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="btn_palette mr-2" id="menu-fondo-activator">
                        <v-icon small>fas fa-palette</v-icon>
                      </v-btn>
                    </template>
                    <span>Color de fondo</span>
                  </v-tooltip>

                  <v-menu activator="#menu-fondo-activator" top nudge-bottom="105" nudge-left="16"
                    :close-on-content-click="false">
                    <v-card>
                      <v-card-text class="pa-0">
                        <v-color-picker v-model="color_fondo" mode="hexa" show-swatches :swatches="swatches"
                          @input="realTimeChange(color_fondo)">
                        </v-color-picker>
                      </v-card-text>
                    </v-card>
                  </v-menu>

                  <v-btn v-if="
                    objectSelected != null &&
                    (objectSelected.data.type == 'video' ||
                      objectSelected.data.type == 'audio')
                  " small dense class="btn_palette mr-2" @click="ReplayMediaSelected()">
                    <v-icon small>fas fa-retweet</v-icon>
                  </v-btn>

                  <v-btn v-if="
                    objectSelected != null &&
                    (objectSelected.data.type == 'video' ||
                      objectSelected.data.type == 'audio')
                  " dense class="btn_palette mr-2" @click="StopMediaSelected()">
                    <v-icon small>fas fa-stop</v-icon>
                  </v-btn>

                  <v-btn v-if="
                    objectSelected != null &&
                    (objectSelected.data.type == 'video' ||
                      objectSelected.data.type == 'audio')
                  " dense class="btn_palette mr-2" @click="PlayPauseMediaSelected()">
                    <v-icon small v-if="objectSelected.data.run == false">fas fa-play</v-icon>
                    <v-icon small v-if="objectSelected.data.run == true">fas fa-pause</v-icon>
                  </v-btn>

                  <BtnComp v-show="objectSelected == null ||
                    objectSelected.data.type != 'texto'
                    " @click="AddTexto()" class="mr-1">
                    Agregar texto
                  </BtnComp>

                  <v-tooltip bottom color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-1" v-on="on" v-show="objectSelected == null ||
                        objectSelected.data.type != 'texto'
                        " @click="BorrarObject()" color="error">
                        <v-icon small> fas fa-trash-alt</v-icon>
                      </v-btn>
                    </template>
                    <span>Borrar elemento</span>
                  </v-tooltip>

                  <!-- <v-btn class="mr-1" v-show="objectSelected == null || objectSelected.data.type != 'texto'"
                @click="AddRectangle()" color="green">
                <v-icon small> fas fa-check</v-icon>
              </v-btn> -->
                </v-toolbar>

                <v-toolbar dense small class="elevation-0">
                  <!-- <v-spacer></v-spacer> -->
                  <div v-if="
                    objectSelected != null &&
                    objectSelected.data.type == 'texto'
                  ">
                    <BtnComp @click="AddTexto()" class="mr-1">
                      Agregar texto
                    </BtnComp>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn class="mr-1" v-on="on" v-show="objectSelected != null" @click="BorrarObject()"
                          color="error">
                          <v-icon small> fas fa-trash-alt</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar elemento</span>
                    </v-tooltip>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="superScript()" small dense text>
                          <v-icon large>mdi-format-superscript</v-icon>
                        </v-btn>
                      </template>
                      <span>Potencia </span>
                    </v-tooltip>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="removeSuper()" small dense text>
                          <v-icon large>mdi-playlist-remove</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover potencia</span>
                    </v-tooltip>

                    <v-menu :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-tooltip bottom color="#1b1b1b">
                          <template v-slot:activator="{ on: tooltipOn }">
                            <v-btn small dense text @click="formulaArea = ''" v-bind="attrs"
                              v-on="{ ...on, ...tooltipOn }">
                              <!-- <v-icon>fa-square-root-alt</v-icon> -->
                              <v-icon large>mdi-function</v-icon>
                            </v-btn>
                          </template>
                          <span>Insertar Fórmula</span>
                        </v-tooltip>
                      </template>
                      <v-card class="border-top">
                        <v-card-title>Creador de Fórmulas</v-card-title>

                        <v-card-subtitle>Crea una expresión:</v-card-subtitle>
                        <v-card-text>
                          <v-textarea @keyup="renderFormula()" dense v-model="formulaArea" rows="1"></v-textarea>

                          <small>Result:</small>
                          <div style="
                              font-size: 17px;
                              color: black;
                              display: inline-block;
                              width: auto;
                              white-space: nowrap;
                              padding: 3px;
                            " ref="mathContainer"></div>

                          <v-btn block color="primary" small @click="addImageToCanvas()" class="mt-5">Insertar
                            expresión</v-btn>
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <v-tooltip bottom color="#1b1b1b">
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="addVinieta()" small dense text>
                          <v-icon large>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Añadir viñetas</span>
                    </v-tooltip>
                  </div>
                </v-toolbar>
              </v-col>

              <v-col cols="12" ref="canvasKWSParent"
                class="canvasKWSParent d-flex flex-column justify-center align-center py-1">
                <canvas id="canvas" class="canvasKWST"></canvas>
              </v-col>
            </v-row>

            <v-row class="py-0 mx-0">
              <v-col cols="12" class="py-0 my-3 mx-0 px-0">
                <template>
                  <v-expansion-panels v-model="alwaysOpen">
                    <v-expansion-panel>
                      <v-expansion-panel-header class="py-0 my-0">
                        <h4>Diapositivas:</h4>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mx-0 px-0">
                        <v-sheet @sorted="cambiarOrdenDiapositivas($event)" v-sortable
                          class="py-0 my-0 text-center custom-scroll" max-width="100%">
                          <div id="divScroll" class="d-flex justify-start overflow-x-visible py-5 custom-scroll"
                            style="overflow-x: scroll">

                            <div class="sortings" v-for="(diapositiva, index) in listDiapositivas"
                              :key="`Diap${index}-${diapositiva.id}`" :value="index" :title="index"
                              :id="diapositiva.id">
                              <v-menu v-model="diapositiva.menu" location="end" :close-on-content-click="false">
                                <template v-slot:activator="{ props }">
                                  <v-card :class="{
                                    zoomed:
                                      selectedDiapositivaIndex === index,
                                  }" max-width="111" class="text-center mx-3 my-1" @click="SelectDiapositiva(index)"
                                    v-bind="props" @click.left.prevent="
                                      diapositiva.menu = false
                                      " @click.right.prevent="
                                        openMenuOptions(diapositiva)
                                        ">
                                    <div>
                                      <!-- ${cacheDinamica} -->
                                      <v-img
                                        v-if="(diapositiva.miniatura != '' && diapositiva.miniatura != undefined) || diapositiva.uri"
                                        width="110" height="60.40" lazy-src="@/assets/placeholder-diapo.svg" :src="diapositiva.miniatura == '' ||
                                          diapositiva.miniatura == undefined
                                          ? `${URL_SPACE}${diapositiva.uri}${cacheDinamica}`
                                          : diapositiva.miniatura
                                          " :key="`screen-${index}`">
                                        <template v-slot:placeholder>
                                          <div class="d-flex align-center justify-center fill-height">
                                            <v-progress-circular color="grey-lighten-4"
                                              indeterminate></v-progress-circular>
                                          </div>
                                        </template>
                                      </v-img>

                                      <v-sheet :color="canvas.backgroundColor || '#FFFFFF'
                                        " v-else height="55" width="111"></v-sheet>
                                    </div>
                                    <h6 class="border-top text-center mx-3 my-1">
                                      {{ diapositiva.orden_diapo }}
                                    </h6>
                                  </v-card>
                                </template>
                                <v-list>
                                  <v-list-item>
                                    <v-list-item-title @click="
                                      AddNewDiapositiva(
                                        diapositiva,
                                        index,
                                        null
                                      )
                                      ">
                                      <v-icon>fa-plus</v-icon> Añadir
                                      página</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="DuplicarDiapositiva(diapositiva)" :disabled="diapositiva.update == true ||
                                    diapositiva.id == null
                                    ">
                                    <v-list-item-title>
                                      <v-icon>fa-copy</v-icon> Duplicar
                                      página</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="
                                    EliminarDiapositiva(diapositiva, index)
                                    ">
                                    <v-list-item-title>
                                      <v-icon>fa-copy</v-icon> Eliminar
                                      página</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="setMostrarAEstudiante(diapositiva)">
                                    <v-list-item-title>
                                      <v-icon v-if="diapositiva.mostrar_a_estudiante">fa-eye</v-icon>
                                      <v-icon v-else>fa-eye-slash</v-icon>
                                      Mostrar página al
                                      estudiante</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                          </div>
                        </v-sheet>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <component :is="compName" :estadoComp="estadoModalConfig" @close="closeComponent" :parametros="parametroConfig"
      @reloadComp="reloadComp">
    </component>
    <Confirm title="¿Desea editar los cambios efectuados?" :active="confirmVolver" @aceptar="ConfirmVolverTrue()"
      @cancelar="ConfirmVolverClose()" />

    <Confirm title="¿Desea guardar los cambios efectuados?" :active="confirmSave" @aceptar="ConfirmSaveTrue()"
      @cancelar="ConfirmSaveClose()" />

    <v-overlay :value="guardando">
      <v-progress-circular indeterminate size="130">
        <h3>Guardando...</h3>
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios, { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import {
  VideoIcon,
  AudioIcon,
  PDFIcon,
  WordIcon,
  XLSIcon,
  XLSXIcon,
} from "@/helpers/axios";
import Confirm from "@/components/confirm";
import { mapGetters, mapMutations } from "vuex";

import loadTemplate from "./template/template";

import TemplateFormComp from "./template/components/TemplateFormComp.vue";

import loadResource from "./resource/resource";
import loadImportDoc from "./import/importDocument";
import LectorDocumentComp from "./lector/document";
import LectorVideoComp from "./lector/video";

import "@/assets/css/galeria.css";
import BtnComp from "@/components/ComponentsEst/BtnComp.vue";
import { fabric } from "fabric";

import Sortable from "sortablejs";
import ButtonComp from "../../../../../components/ComponentsEst/TableButtonComp.vue";
import katex from "katex";
import "katex/dist/katex.min.css";
import html2canvas from "html2canvas";
// import listaDiapositivas from '@/views/Academico/GestionContenidoColegio/listaDiapositivas.vue';

export default {
  name: "GestorDiapositiva",
  props: ["estadoComp", "parametros"],

  components: {
    // visorContenido,
    Confirm,
    loadTemplate,
    TemplateFormComp,
    loadResource,
    loadImportDoc,
    LectorDocumentComp,
    LectorVideoComp,
    BtnComp,
    ButtonComp,
  },
  inject: {
    theme: {
      default: { isDark: false },
    },
  },

  data() {
    return {
      formulaArea: null,
      formula: "",
      selectedText: null,
      selectedDiapositivaIndex: null,
      deleteIcon:
        "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E",
      clipboard: null,
      formulaText: "",
      paginationData: {},
      timecomputed: new Date().getTime(),
      prevKlass: null,
      buscando: 0,
      paginaActual: 1,
      totalPaginas: 0,
      tamañoPorPagina: 5,
      totalFilas: 0,
      messageVacio: false,
      loadingVideo: [],
      alwaysOpen: 0,
      datoLogin: sessionStorage,
      URL_SPACE: BUCKET_ORIGIN_SPACE,
      evento: null,
      paramComponente: { id_submodulo: 22, id_modulo: 4 },
      test: false,
      compName: "",
      estadoModalConfig: false,
      parametroConfig: {},

      confirmVolver: false,
      confirmSave: false,
      itemDelete: "",
      dialog_confirm: false,

      dataSet: {},
      filtro: {},
      viewGC: true,

      titleTemp: "",
      activateFiltroMenu: false,
      activateTemplate: false,
      activateDocument: false,
      activateResource: false,

      miniaturaSelected: null,
      listTemplate: [],
      listResourse: [],
      listNivel: [],
      listArea: [],
      listDiapositivas: [],
      diapositivaSeleccionada: 0,
      diapositivaDestino: 0,
      addNewDestino: false,
      baseDiapositiva: {
        update: false,
        background: "#FFFFFF",
        backgroundCurrent: "#FFFFFF",
        canvas: "",
        miniatura: "",
        orden_diapo: "1",
        nombre_diapositiva: "1",
        estado_diapositiva: true,
        menu: false,
        mostrar_a_estudiante: true,
        editingTitle: false,
      },
      validarDiaposExisten: null,
      listTipoRecurso: [
        { id: "img", descripcion: "Imágenes" },
        { id: "doc", descripcion: "Documento" },
        { id: "vid", descripcion: "Video" },
        { id: "aud", descripcion: "Audio" },
      ],

      listAcceso: [
        { id: 1, descripcion: "Público" },
        { id: 2, descripcion: "Privado" },
      ],

      color_fondo: "#FFFFFF",
      swatches: [
        ["#FFFFFF00", "#AA0000", "#550000"],
        ["#FFFF00", "#AAAA00", "#555500"],
        ["#00FF00", "#00AA00", "#005500"],
        ["#00FFFF", "#00AAAA", "#005555"],
        ["#0000FF", "#0000AA", "#000055"],
      ],

      rul: {
        required: (value) => !!value || "Campo Requerido",
        max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      },

      orden: 0,

      textConfig: {
        fonts: [
          {
            name: "Default",
            value: "Comic Sans MS',cursive",
          },
          // Times,serif
          {
            name: "Arial",
            value: "Arial,Helvetica,sans-serif",
          },
          {
            name: "Comic Sans MS",
            value: "'Comic Sans MS',cursive",
          },
          {
            name: "Courier New",
            value: "'Courier New',Courier,monospace",
          },
          {
            name: "Georgia",
            value: "Georgia,serif",
          },
          {
            name: "Lucida Sans Unicode",
            value: "'Lucida Sans Unicode','Lucida Grande',sans-serif",
          },
          {
            name: "Tahoma",
            value: "Tahoma,Geneva,sans-serif",
          },
          {
            name: "Times New Roman",
            value: "'Times New Roman', Times, serif",
          },
          {
            name: "Trebuchet MS",
            value: "'Trebuchet MS',Helvetica,sans-serif",
          },
          {
            name: "Trebuchet MS",
            value: "'Trebuchet MS',Helvetica,sans-serif",
          },
          {
            name: "Verdana",
            value: "Verdana,Geneva,sans-serif",
          },
        ],
      },
      defaultValue: "Your default value",
      fontSize: 20,
      fontFamily: "Comic Sans MS",
      canvas: null,
      widthScene: null,
      heightScene: null,
      objectSelected: null,
      guardando: false,
      cargando: true,

      // config video.js for full screem
      videoOptions: {
        autoplay: false,
        controls: true,
        sources: [
          {
            src: "",
            type: "video/mp4",
          },
        ],
        controlBar: {
          pictureInPictureToggle: false,
        },
      },

      searchTimeController: null,

      x: 0,
      y: 0,
      showMenu: {},
    };
  },

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    swatchStyle() {
      return {
        color: this.objectSelected.fill,
        cursor: "pointer",
        borderRadius: "4px",
      };
    },
    cacheDinamica() {
      let tm = this.timecomputed;
      return `?nocache=${(tm += 1)}`;
    },
  },

  mounted() {
    this.LoadMain();
    document.addEventListener("keydown", this.detectaTeclas);
  },
  beforeDestroy() {
    this.DetenerVideosYAudios();
    document.removeEventListener("keydown", this.detectaTeclas);
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.viewGC = true;
        this.LoadMain();
      } else {
        this.viewGC = false;
        this.LimpiarForm();
      }
    },
    // filtro(data) {
    //   console.log(data);
    // },

    color_fondo(newValor) {
      this.EventBackground(newValor);
    },

  },

  directives: {
    sortable: {
      bind(el, binding, vnode) {
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit("sorted", event);
          },
        };
        Sortable.create(el.getElementsByTagName("div")[0], options);
      },
    },
  },

  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    renderFormula() {
      this.formula = this.transformToLatex(this.formulaArea);
      katex.render(this.formula, this.$refs.mathContainer, {
        throwOnError: false,
      });
    },

    transformToLatex(formula) {
      return formula.replace(/(\d+|\w+)\/(\d+|\w+)/g, "\\frac{$1}{$2}");
    },

    addImageToCanvas() {
      const container = this.$refs.mathContainer;
      container.style.backgroundColor = "transparent";
      container.style.boxShadow = "none";
      container.style.border = "none";
      html2canvas(container, { backgroundColor: null, scale: 3 })
        .then((canvas) => {
          // Obtenemos el dataURL de la imagen generada
          const dataUrl = canvas.toDataURL("image/png", 1.0);
          fabric.Image.fromURL(
            dataUrl,
            (imgInstance) => {
              // Configuraciones adicionales para la instancia de la imagen
              imgInstance.set({
                crossOrigin: "anonymous",
                data: { type: "text", fileLink: dataUrl },
              });
              this.canvas.add(imgInstance);
              this.canvas.renderAll();
            },
            {
              crossOrigin: "Anonymous", // Establecer crossOrigin para la solicitud de la imagen
            }
          );
        })
        .catch((error) => {
          console.error("Error al convertir a imagen:", error);
        });
    },

    /**
     ___________________________________________
    |          MÉTODO CARGAR INICIAL          */
    async LoadMain() {
      // this.renderFormula();


      this.timecomputed = new Date().getTime();
      document.documentElement.style.overflow = "auto";
      this.LimpiarForm();
      this.dataSet = this.parametros.item; //SE ALMACENAN LOS PROPS EN LA PROPIEDAD
      this.getNivel(this.dataSet.id_pais);
      this.filtro.id_pais = this.dataSet.id_pais;
      this.dataSet.miniatura = true;

      if (this.parametros.evento == "editar") {

        this.EditItem(this.parametros.item);

      } else {

        this.GetDiapositivas(this.dataSet.id_clase, null, false); //OBTIENE LAS DIAPOSITIVAS RENDERIZADAS

      }
      // Eliminar elementos con suprimir
      document.onkeydown = (e) => {
        if (this.objectSelected && e.which == 46) {
          if (this.objectSelected.data.type == "texto") {
            if (!this.objectSelected.isEditing) this.BorrarObject();
          } else {
            this.BorrarObject();
          }
        }
      };

    },
    // eslint-disable-next-line no-unused-vars
    handleScroll(evt) {
      // console.log(evt);
      // if (window.scrollY > 50) {
      //   el.setAttribute(
      //     'style',
      //     'opacity: 1; transform: translate3d(0, -10px, 0)'
      //   )
      // }
      // return window.scrollY > 100
      this.listTemplate.forEach((template) => {
        this.$set(this.showMenu, template.id, false);
      });
    },

    menuTemplate(e, template) {
      // console.log({template});
      // Asegurar que todos los menús están cerrados inicialmente
      Object.keys(this.showMenu).forEach((key) => {
        this.showMenu[key] = false;
      });
      // Configurar las coordenadas del clic
      this.x = e.clientX;
      this.y = e.clientY;
      // Usar $nextTick para cambiar el estado después de la actualización del DOM
      this.$nextTick(() => {
        this.showMenu[template.id] = true; // Solo abrir el menú del template actual
      });
    },
    /**
     ________________________________________________
    |          MÉTODO LISTAR DIAPOSITIVAS          */
    async GetDiapositivas(id_clase, id_diapositiva_select, addNew) {

      this.cargando = true;

      try {
        let response = await axios.get(
          `/manager/contenido/contenidoDiap/${id_clase}`
        );
        const promesas = response.data.payload.map((d) => {
          return {
            ...d.diapositiva,
            // canvas: JSON.stringify(arrayCanvas),
            menu: false,
            orden_diapo: d.orden,
            editingTitle: false,
            update: false,
            backgroundCurrent: d.background,
          };
        });
        this.validarDiaposExisten = promesas.length == 0 ? false : true;
        this.listDiapositivas = await Promise.all(promesas);

        if (this.listDiapositivas.length > 0) {

          if (id_diapositiva_select) {
            const index = this.listDiapositivas.findIndex(
              (d) => d.id == id_diapositiva_select
            );
            if (index > -1) this.diapositivaSeleccionada = index;
          }

          if (addNew == true) {
            let data = { ...this.baseDiapositiva };
            data.orden_diapo = `${this.listDiapositivas.length + 1}`;
            this.listDiapositivas.push(data);
            this.diapositivaSeleccionada = this.listDiapositivas.length - 1;
            this.color_fondo = data.backgroundCurrent;
            this.LoadFabric(true);

          } else {
            this.color_fondo =
              this.listDiapositivas[
                this.diapositivaSeleccionada
              ].backgroundCurrent;
            await this.CargarDiapositiva(
              this.listDiapositivas[this.diapositivaSeleccionada].canvas,
              true
            );
          }
        } else {


          await this.GetTemplateDefault({
            id_area: this.parametros.item.id_area,
            id_nivel: this.parametros.item.id_nivel_grado,
            estado_template: true,
            id_acceso: "",
            id_pais: 145,
            id_tipo_recurso: "",
            search
              :
              ""
          })
        }
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     ______________________________________________________
    |          MÉTODO AGREGAR NUEVA DIAPOSITIVA          */
    async AddNewDiapositiva(
      diapositiva = null,
      index = null,
      importBase64 = null
    ) {

      if (!this.guardando) {
        if (diapositiva) diapositiva.menu = false;

        if (index && index >= 0) this.diapositivaSeleccionada = index;

        if (
          (this.listDiapositivas[this.diapositivaSeleccionada].update == true ||
            !this.listDiapositivas[this.diapositivaSeleccionada].id) &&
          !importBase64
        ) {
          this.addNewDestino = true;
          this.ConfirmSaveShow();
        } else {
          this.addNewDestino = false;
          let data = { ...this.baseDiapositiva };
          data.orden_diapo = `${this.listDiapositivas.length + 1}`;
          this.listDiapositivas.push(data);
          this.diapositivaSeleccionada = this.listDiapositivas.length - 1;
          this.color_fondo = data.backgroundCurrent;

          this.LoadFabric(true);
        }
      } else {
        if (importBase64) {

          this.addNewDestino = false;
          let data = { ...this.baseDiapositiva };

          data.orden_diapo = `${this.listDiapositivas.length + 1}`;

          if (this.validarDiaposExisten) {
            this.listDiapositivas.push(data);
          }

          this.diapositivaSeleccionada = this.listDiapositivas.length - 1;
          this.color_fondo = data.backgroundCurrent;

          this.LoadFabric(true);
        }
      }

      if (importBase64) {
        await this.LoadImage(importBase64);
        await this.ChangeDiapositiva(false, false, false, true);
      }
    },
    /**
     ________________________________________________
    |          MÉTODO CAMBIAR DIAPOSITIVA          */
    async ChangeDiapositiva(callback, close = false, reload = false, isImporting) {

      this.DetenerVideosYAudios();
      this.objectSelected = null;

      try {

        let canvasJson = await this.canvas.toJSON(["data", "fontVariant"]);
        canvasJson["widthScene"] = this.widthScene;
        canvasJson["heightScene"] = this.heightScene;
        let objects = this.canvas.getObjects();

        for (let index = 0; index < objects.length; index++) {
          if (objects[index].data.type == "texto") {
            canvasJson.objects[index].styles = objects[index].styles;
          }
        }

        this.listDiapositivas[this.diapositivaSeleccionada].canvas = JSON.stringify(canvasJson);
        this.listDiapositivas[this.diapositivaSeleccionada].miniatura = await this.canvas.toDataURL("image/png", 0.1);
        this.guardando = false;

      } catch (error) {
        console.log(error);
      } finally {
        await this.SaveItem(close, reload, isImporting);
      }

      if (typeof callback == "function") callback();
      this.confirmVolver = false;
      return this.listDiapositivas[this.diapositivaSeleccionada].canvas;
    },




    async cargarDefaultDiap(canvas) {

      this.LoadFabric(true);
      if (canvas.objects != undefined) {
        canvas.objects = canvas.objects.map((item) => {
          switch (item.data.type) {
            case "imagen":
              if (!item.src.includes('https://')) {
                item.data.fileLink = this.URL_SPACE + item.src + this.cacheDinamica;
                return { ...item, src: this.URL_SPACE + item.src + this.cacheDinamica };
              } else {
                item.data.fileLink = item.src;
                return { ...item, src: item.src };
              }

            case "video":
              if (!item.objects[1].objects[1].src.includes(this.URL_SPACE)) {
                item.objects[1].objects[1].src = this.URL_SPACE + VideoIcon;
                return { ...item };
              } else {
                return { ...item };
              }

            case "documento":
              if (!item.objects[0].src.includes(this.URL_SPACE)) {
                item.objects[0].src = this.URL_SPACE + PDFIcon;
                item.data.fileLink = this.URL_SPACE + item.data.fileLink;
                return { ...item };
              } else {
                return { ...item };
              }

            case "audio":
              if (!item.src.includes(this.URL_SPACE)) {
                item.src = this.URL_SPACE + AudioIcon;
                return { ...item };
              } else {
                return { ...item };
              }

            default:
              return { ...item };
          }
        });
      }
      this.canvas.loadFromJSON(canvas, () => {
        this.canvas.forEachObject((object) => {
          object.set({ cache: true });
        });

        let videosSinElemento = this.canvas.getObjects().filter(
          (obj) =>
            obj.data.type == "video" &&
            // obj.getObjects == "function" &&
            (JSON.stringify(
              obj.getObjects()[1].getObjects()[0].getElement()
            ) === "{}" ||
              obj.getObjects()[1].getObjects()[0].getElement() == null)
        );

        videosSinElemento.forEach((obj) => {
          this.ActualizarElementoVideo(obj);
        });

        let audiosSinElemento = this.canvas
          .getObjects()
          .filter(
            (obj) =>
              obj.data.type == "audio" &&
              (JSON.stringify(obj.data.element) === "{}" ||
                obj.data.element == null)
          );

        audiosSinElemento.forEach((obj) => {
          this.ActualizarElementoAudio(obj);
        });

        let textosSinFondo = this.canvas
          .getObjects()
          .filter(
            (obj) => obj.data.type == "texto" && !obj.data.backgroundColor
          );
        textosSinFondo.forEach((obj) => {
          obj.set("backgroundColor", `#FFFFFF00`);
          obj.data.backgroundColor = `#FFFFFF00`;
        });

        let objects = this.canvas.getObjects();

        let canvasJ =
          typeof canvas === "object" ? canvas : JSON.parse(canvas);
        if (
          canvasJ.hasOwnProperty("widthScene") &&
          canvasJ["widthScene"] != this.widthScene
        ) {
          let scaleMultiplier = this.widthScene / canvasJ["widthScene"];
          for (var i in objects) {
            objects[i].scaleX = objects[i].scaleX * scaleMultiplier;
            objects[i].scaleY = objects[i].scaleY * scaleMultiplier;
            objects[i].left = objects[i].left * scaleMultiplier;
            objects[i].top = objects[i].top * scaleMultiplier;
            objects[i].setCoords();
          }
        }
        for (let index = 0; index < objects.length; index++) {
          this.setStyleCorner(objects[index]);
        }

        this.Render();
        this.cargando = false;
      });
    },



    /**
     ____________________________________________________________
    |          MÉTODO CARGAR Y RENDERIZAR DIAPOSITIVA          */
    async CargarDiapositiva(canvas, resetCanvas = false) {
      this.cargando = true;
      if (
        resetCanvas == true ||
        !this.canvas ||
        !this.listDiapositivas[this.diapositivaSeleccionada].id
      )
        this.LoadFabric(true);

      if (canvas) {
        if (canvas.objects != undefined) {
          canvas.objects = canvas.objects.map((item) => {
            switch (item.data.type) {
              case "imagen":
                if (!item.src.includes('https://')) {
                  item.data.fileLink = this.URL_SPACE + item.src + this.cacheDinamica;
                  return { ...item, src: this.URL_SPACE + item.src + this.cacheDinamica };
                } else {
                  item.data.fileLink = item.src;
                  return { ...item, src: item.src };
                }

              case "video":
                if (!item.objects[1].objects[1].src.includes(this.URL_SPACE)) {
                  item.objects[1].objects[1].src = this.URL_SPACE + VideoIcon;
                  return { ...item };
                } else {
                  return { ...item };
                }

              case "documento":
                if (!item.objects[0].src.includes(this.URL_SPACE)) {
                  item.objects[0].src = this.URL_SPACE + PDFIcon;
                  item.data.fileLink = this.URL_SPACE + item.data.fileLink;
                  return { ...item };
                } else {
                  return { ...item };
                }

              case "audio":
                if (!item.src.includes(this.URL_SPACE)) {
                  item.src = this.URL_SPACE + AudioIcon;
                  return { ...item };
                } else {
                  return { ...item };
                }

              default:
                return { ...item };
            }
          });
        }

        this.canvas.loadFromJSON(canvas, () => {
          this.canvas.forEachObject((object) => {
            object.set({ cache: true });
          });

          let videosSinElemento = this.canvas.getObjects().filter(
            (obj) =>
              obj.data.type == "video" &&
              // obj.getObjects == "function" &&
              (JSON.stringify(
                obj.getObjects()[1].getObjects()[0].getElement()
              ) === "{}" ||
                obj.getObjects()[1].getObjects()[0].getElement() == null)
          );

          videosSinElemento.forEach((obj) => {
            this.ActualizarElementoVideo(obj);
          });

          let audiosSinElemento = this.canvas
            .getObjects()
            .filter(
              (obj) =>
                obj.data.type == "audio" &&
                (JSON.stringify(obj.data.element) === "{}" ||
                  obj.data.element == null)
            );

          audiosSinElemento.forEach((obj) => {
            this.ActualizarElementoAudio(obj);
          });

          let textosSinFondo = this.canvas
            .getObjects()
            .filter(
              (obj) => obj.data.type == "texto" && !obj.data.backgroundColor
            );
          textosSinFondo.forEach((obj) => {
            obj.set("backgroundColor", `#FFFFFF00`);
            obj.data.backgroundColor = `#FFFFFF00`;
          });

          let objects = this.canvas.getObjects();

          let canvasJ =
            typeof canvas === "object" ? canvas : JSON.parse(canvas);

          // if (canvasJ.hasOwnProperty("widthScene") && canvasJ["widthScene"] != this.widthScene) {

          //   let scaleMultiplier = this.widthScene / canvasJ["widthScene"];
          //   for (var i in objects) {
          //     objects[i].scaleX = objects[i].scaleX * scaleMultiplier;
          //     objects[i].scaleY = objects[i].scaleY * scaleMultiplier;
          //     objects[i].left = objects[i].left * scaleMultiplier;
          //     objects[i].top = objects[i].top * scaleMultiplier;
          //     objects[i].setCoords();
          //   }

          // }

          if (canvasJ.widthScene != this.widthScene) {
            const m = this.widthScene / canvasJ.widthScene;
            objects.forEach(o => {
              if (o.data.type === 'texto') {
                // ¡Redimensiona la fuente de verdad!
                o.fontSize *= m;
                o.scaleX = o.scaleY = 1;
              } else {
                o.scaleX *= m;
                o.scaleY *= m;
              }
              o.left *= m;
              o.top *= m;
              o.setCoords();
            });
          }
          for (let index = 0; index < objects.length; index++) {
            this.setStyleCorner(objects[index]);
          }

          this.Render();
          this.cargando = false;
        });
      } else {
        this.cargando = false;
      }
    },
    /**
     __________________________________________________
    |          MÉTODO DUPLICAR DIAPOSITIVAS          */
    async DuplicarDiapositiva(diapositiva) {
      diapositiva.menu = false;
      let data = { ...diapositiva, id: null };
      delete data["id_contenido"];
      this.listDiapositivas.push(data);
      this.diapositivaSeleccionada = this.listDiapositivas.length - 1;
      await this.CargarDiapositiva(
        this.listDiapositivas[this.diapositivaSeleccionada].canvas
      );
      let myDiv = document.getElementById("divScroll");
      setTimeout(() => {
        myDiv.scrollLeft = myDiv.scrollWidth;
        this.ConfirmSaveShow();
      }, 400);
    },
    /**
     ________________________________________________
    |          MÉTODO ELIMINAR PLANTILLAS          */
    async EliminarPlantilla(idtemplate, index) {
      this.listTemplate.splice(index, 1);

      try {
        const resp = await axios.put(
          "/manager/contenido/eliminarTemplate/" + idtemplate
        );

        if (resp.status === 200) {
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: `${resp.data.message}`,
            tiempo: null,
          });

          this.GetTemplate();
        }
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    /**
     __________________________________________________
    |          MÉTODO ELIMINAR DIAPOSITIVAS          */
    async EliminarDiapositiva(diapositiva, index) {

      console.log({ index });
      console.log({ diapositiva });

      try {

        diapositiva.menu = false;

        if (diapositiva.id) {

          let realId = diapositiva.id;

          const resp = await axios.put(
            "/manager/contenido/detd/inac/" + realId
          );
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: `${resp.data.message}`,
            tiempo: null,
          });
        }

        this.listDiapositivas.splice(index, 1);

        if (this.listDiapositivas.length == 0) {
          this.diapositivaSeleccionada = 0;
          this.listDiapositivas = [{ ...this.baseDiapositiva }];
        } else {
          this.diapositivaSeleccionada = index - 1 < 0 ? 0 : index - 1;
        }

        await this.CargarDiapositiva(
          this.listDiapositivas[this.diapositivaSeleccionada].canvas
        );
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _____________________________________________________
    |          MÉTODO SELECCIONAR DIAPOSITIVAS          */
    async SelectDiapositiva(index) {
      this.DetenerVideosYAudios();

      this.selectedDiapositivaIndex = index;

      try {
        // setTimeout(async() => {
        if (!this.guardando) {
          // if (index != this.diapositivaSeleccionada && !this.guardando) {
          if (
            this.listDiapositivas[this.diapositivaSeleccionada].update ==
            true ||
            !this.listDiapositivas[this.diapositivaSeleccionada].id && !this.listDiapositivas[this.diapositivaSeleccionada].base
          ) {

            this.diapositivaDestino = index;
            this.ConfirmSaveShow();
          } else {
            this.diapositivaSeleccionada = index;

            this.color_fondo = this.listDiapositivas[this.diapositivaSeleccionada].backgroundCurrent || 'white';
            await this.CargarDiapositiva(
              this.listDiapositivas[this.diapositivaSeleccionada].canvas,
              false
            );
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.listDiapositivas[this.diapositivaSeleccionada].update = false;
      }
    },
    /**
     _______________________________________________
    |          MÉTODO INFINITE SCROLLING          */
    async checkScrollMetodo() {
      const checkScroll = this.$refs.scrollFetch;
      if (checkScroll) {
        const scrollPositionBefore = checkScroll.scrollTop;
        const totalHeight = checkScroll.scrollHeight;
        const scrollPosition = checkScroll.scrollTop + checkScroll.clientHeight;

        if (scrollPosition >= totalHeight - 1) {
          const totalHeightAfter = checkScroll.scrollHeight;
          const heightDifference = totalHeightAfter - totalHeight;
          checkScroll.scrollTop = scrollPositionBefore + heightDifference;
          this.paginaActual += 1;
          await this.GetResource();
          return;
        }
      }
    },
    /**
     _________________________________________________________
    |          MÉTODO MODIFICAR ORDEN DIAPOSITIVAS          */
    cambiarOrdenDiapositivas(event) {
      const ordenNew = event.newIndex + 1;
      const movedItem = this.listDiapositivas.splice(event.oldIndex, 1)[0];
      this.listDiapositivas.splice(event.newIndex, 0, movedItem);
      this.listDiapositivas[event.newIndex].orden_diapo = ordenNew;

      this.SelectDiapositiva(event.newIndex);

      this.listDiapositivas.forEach((diapositiva, index) => {
        diapositiva.orden_diapo = index + 1;
        this.modificarOrdenDiapositivas(
          this.dataSet.id_clase,
          diapositiva.id,
          index + 1
        );
      });
    },
    /**
     ________________________________________________________
    |          MÉTODO EJECUTAR CAMBIO ORDEN DIAPOS         */
    async modificarOrdenDiapositivas(id_clase, id, newIndex) {
      try {
        await axios.put("/manager/contenido/actualizaIndice/" + id_clase, {
          orden_new: newIndex,
          id: id,
        });
      } catch (error) {
        console.log(error);
      }
    },
    /**
     __________________________________________________
    |          MÉTODO AÑADIR VIDEO A LIENZO          */
    LoadVideo(id, fileLink) {
      this.loadingVideo.push(id);
      this.listDiapositivas[this.diapositivaSeleccionada].update = true;

      const videoElem = this.SetUpVideo(fileLink);

      videoElem.onloadeddata = () => {
        videoElem.width = videoElem.videoWidth;
        videoElem.height = videoElem.videoHeight;

        let video1 = new fabric.Image(videoElem, {
          crossOrigin: "anonymous",
          originX: "center",
          originY: "center",
          objectCaching: false,
          visible: false,
        });

        fabric.Image.fromURL(
          this.URL_SPACE + VideoIcon,
          (myImg) => {
            let baseGroup = new fabric.Group([video1, myImg], {
              // width: videoElem.videoWidth,
              // height: videoElem.videoHeight,
              setOnGroup: false,
              objectCaching: false,
            });

            let textBoundingRect = baseGroup.getBoundingRect();

            let background = new fabric.Rect({
              top: textBoundingRect.top,
              left: textBoundingRect.left,
              width: textBoundingRect.width,
              height: textBoundingRect.height,
              fill: "black",
            });

            let group = new fabric.Group([background, baseGroup], {
              width: videoElem.videoWidth,
              height: videoElem.videoHeight,
              setOnGroup: false,
              objectCaching: false,
              scaleX: 0.4,
              scaleY: 0.4,
            });

            group.data = {
              type: "video",
              run: false,
              fileLink,
              element: videoElem,
            };

            this.canvas.add(group);
            this.canvas.centerObject(group);

            this.Render();
          },
          {
            crossOrigin: "anonymous",
            originX: "center",
            originY: "center",
            // scaleX: 1,
            // scaleY: 1,
          }
        );
      };
      setTimeout(async () => {
        this.loadingVideo.splice(this.loadingVideo.indexOf(id), 1);
      }, 500);
    },
    /**
     __________________________________________________________
    |          MÉTODO CREAR ETIQUETA VIDEO + SOURCE          */
    SetUpVideo(source) {
      let _videoDOMElement = document.createElement("video");

      _videoDOMElement.setAttribute("preload", "auto");
      _videoDOMElement.setAttribute("playsinline", "playsinline");
      _videoDOMElement.setAttribute("webkit-playsinline", "webkit-playsinline");
      _videoDOMElement.muted = false;
      _videoDOMElement.autoplay = false;
      _videoDOMElement.controls = true;
      _videoDOMElement.crossOrigin = "anonymous";

      let nSourceDOMElement = document.createElement("source");
      nSourceDOMElement.src = this.URL_SPACE + source;
      nSourceDOMElement.type = "video/mp4";
      _videoDOMElement.appendChild(nSourceDOMElement);

      return _videoDOMElement;
    },
    /**
     __________________________________________________
    |          MÉTODO AÑADIR AUDIO A LIENZO          */
    LoadAudio(fileLink) {
      this.listDiapositivas[this.diapositivaSeleccionada].update = true;
      let audioElem = this.SetUpAudio(fileLink);

      let image = document.createElement("img");
      image.src = this.URL_SPACE + AudioIcon;
      image.crossOrigin = "anonymous";

      image.onload = () => {
        let imgInstance = new fabric.Image(image, {
          crossOrigin: "anonymous",
        });

        imgInstance.data = {
          element: audioElem,
          type: "audio",
          run: false,
          fileLink: fileLink,
        };

        this.setStyleCorner(imgInstance);

        imgInstance.scaleToHeight(100);
        imgInstance.scaleToWidth(100);
        this.canvas.add(imgInstance);
        this.canvas.centerObject(imgInstance);
        this.Render();
      };
    },
    /**
     _________________________________________________
    |          MÉTODO CREAR ETIQUETA AUDIO          */
    SetUpAudio(source) {
      let audioDOMElement = document.createElement("audio");

      // performance
      audioDOMElement.controls = "controls";
      audioDOMElement.autoplay = false;
      audioDOMElement.crossOrigin = "anonymous";

      let sourceDOMElement = document.createElement("source");
      sourceDOMElement.src = this.URL_SPACE + source;
      audioDOMElement.appendChild(sourceDOMElement);

      return audioDOMElement;
    },
    /**
     ______________________________________________________
    |          MÉTODO AÑADIR DOCUMENTO A LIENZO          */
    AddDocumento(item) {
      let image = document.createElement("img");
      image.crossOrigin = "anonymous"; // Establecer esto antes de asignar el 'src'
      this.listDiapositivas[this.diapositivaSeleccionada].update = true;
      switch (item.file_ext) {
        case ".pdf":
          image.src = this.URL_SPACE + PDFIcon;
          break;
        case ".doc":
          image.src = this.URL_SPACE + WordIcon;
          break;
        case ".docx":
          image.src = this.URL_SPACE + WordIcon;
          break;
        case ".xls":
          image.src = this.URL_SPACE + XLSIcon;
          break;
        case ".xlsx":
          image.src = this.URL_SPACE + XLSXIcon;
          break;
        default:
          image.src = this.URL_SPACE + PDFIcon;
          break;
      }

      image.onload = () => {
        let img = new fabric.Image(image, {
          crossOrigin: "anonymous",
        });

        img.scaleToWidth(70);

        let text = new fabric.Text(item.file_desc, {
          fontFamily: "Comic Sans MS",
          fontSize: 20,
        });
        text.set({ top: -30 });

        let group = new fabric.Group([img, text], {
          objectCaching: false,
        });
        group.data = {
          type: "documento",
          fileLink: this.URL_SPACE + item.file_link,
          file_desc: item.file_desc,
          file_ext: item.file_ext,
        };
        this.setStyleCorner(group);
        this.canvas.centerObject(group);
        this.canvas.add(group);
        this.Render();
      };
    },
    /**
     ___________________________________________________
    |          MÉTODO AÑADIR IMAGEN A LIENZO          */
    async LoadImage(fileLink) {
      this.listDiapositivas[this.diapositivaSeleccionada].update = true;
      await this.AddImage(fileLink);
    },
    /**
     _________________________________________
    |          MÉTODO CREAR IMAGEN          */
    async AddImage(fileLink) {
      return new Promise((resolve, reject) => {

        const url = this.URL_SPACE + fileLink + this.cacheDinamica; // Completa URL de la imagen

        // Usar fabric.Image.fromURL para cargar la imagen
        fabric.Image.fromURL(
          url,
          (imgInstance) => {
            // Configuraciones adicionales para la instancia de la imagen
            imgInstance.set({
              crossOrigin: "anonymous",
              data: { type: "imagen", fileLink: fileLink },
            });

            // Estilizar y escalar la imagen si es necesario
            this.setStyleCorner(imgInstance);
            if (this.heightScene < imgInstance.height) {
              imgInstance.scaleToHeight(this.heightScene / 1.5);
            }

            // Añadir la imagen al canvas y centrarla
            this.canvas.add(imgInstance);
            this.canvas.centerObject(imgInstance);
            this.Render();

            resolve();
          },
          {
            crossOrigin: "Anonymous", // Establecer crossOrigin para la solicitud de la imagen
          }
        );
      });
    },
    /**
     _____________________________________________________
    |          MÉTODO CONVERSION CANVAS A FILE          */
    async canvastoFile(diapositiva) {
      let dataurl = diapositiva.miniatura;
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], `${diapositiva.orden_diapo}.png`, {
        type: mime,
      });
    },
    /**
     __________________________________________
    |          MÉTODO CARGAR LIENZO          */
    async CargarScene(data) {
      await this.CargarDiapositiva(data.canvas);
    },
    /**
     _____________________________________________
    |          MÉTODO GUARDAR DIAPOSITIVA       */
    async SaveItem(close = false, reload = true, isImporting) {

      if (!isImporting) {
        this.guardando = true;
      }

      let canvasMod = JSON.parse(
        this.listDiapositivas[this.diapositivaSeleccionada]["canvas"]
      );

      // MODIFICACIÓN DE LOS OBJETOS DE LA VARIABLE CANVAS
      let objects = canvasMod.objects;

      for (let index = 0; index < objects.length; index++) {
        switch (objects[index].data.type) {
          case "imagen":
            if (objects[index].data.fileLink.includes(this.URL_SPACE)) {
              objects[index].src = objects[index].data.fileLink.replace(this.URL_SPACE, "");
            }
            else if (objects[index].data.fileLink.includes('https://s301-inteligenio.s3.amazonaws.com')) {
              objects[index].src = objects[index].data.fileLink.replace('https://s301-inteligenio.s3.amazonaws.com', "");
            }

            objects[index].data.fileLink = objects[index].src;
            break;

          case "video":
            if (VideoIcon.includes(this.URL_SPACE)) {
              objects[index].objects[1].objects[1].src = VideoIcon.replace(this.URL_SPACE, "");
            }
            else if (VideoIcon.includes('https://s301-inteligenio.s3.amazonaws.com')) {
              objects[index].objects[1].objects[1].src = VideoIcon.replace('https://s301-inteligenio.s3.amazonaws.com', "");
            }
            break;

          case "documento":
            if (objects[index].data.fileLink.includes(this.URL_SPACE)) {
              objects[index].data.fileLink = objects[index].data.fileLink.replace(this.URL_SPACE, "");
              objects[index].objects[0].src = PDFIcon;
            }
            else if (objects[index].data.fileLink.includes('https://s301-inteligenio.s3.amazonaws.com')) {
              objects[index].data.fileLink = objects[index].data.fileLink.replace('https://s301-inteligenio.s3.amazonaws.com', "");
              objects[index].objects[0].src = PDFIcon;
            }
            break;

          case "audio":
            objects[index].src = AudioIcon;
            break;
        }
      }

      try {
        let formData = new FormData();
        formData.append("id_usuario", this.datoLogin.id);
        formData.append("id_colegio", this.datoLogin.id_colegio);
        formData.append("id_clase", this.dataSet.id_clase);
        formData.append("tipo", "DS");
        formData.append("canvas", JSON.stringify(canvasMod));
        formData.append(
          "nombre_diapositiva",
          this.listDiapositivas[this.diapositivaSeleccionada]["orden_diapo"]
        );
        formData.append(
          "background",
          this.listDiapositivas[this.diapositivaSeleccionada][
          "backgroundCurrent"
          ]
        );
        formData.append(
          "mostrar_a_estudiante",
          this.listDiapositivas[this.diapositivaSeleccionada][
          "mostrar_a_estudiante"
          ]
        );
        formData.append(
          "estado_diapositiva",
          this.listDiapositivas[this.diapositivaSeleccionada][
          "estado_diapositiva"
          ]
        );

        if (this.listDiapositivas[this.diapositivaSeleccionada]["miniatura"]) {
          formData.append(
            "miniatura",
            await this.canvastoFile(
              this.listDiapositivas[this.diapositivaSeleccionada]
            )
          );
        }

        var resp = "";
        if (this.listDiapositivas[this.diapositivaSeleccionada]["id"]) {
          formData.append(
            "id_contenido",
            this.listDiapositivas[this.diapositivaSeleccionada]["id_contenido"]
          );

          resp = await axios.put(
            `/manager/contenido/contenidoDiap/${this.listDiapositivas[this.diapositivaSeleccionada]["id"]
            }`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        } else {

          resp = await axios.post(
            `/manager/contenido/contenidoDiap/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          this.listDiapositivas[this.diapositivaSeleccionada]["id"] =
            resp.data.data.id;
        }

        this.listDiapositivas[this.diapositivaSeleccionada].update = false;
        this.guardando = false;

        if (close == true) {
          this.Close();

          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: resp.data.message,
            tiempo: null,
          });
        } else if (reload == true) {
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: resp.data.message,
            tiempo: null,
          });
          this.Close();
          await this.GetDiapositivas(
            this.dataSet.id_clase,
            this.listDiapositivas[this.diapositivaSeleccionada].id
          );
        }
        return resp.data;
      } catch (e) {
        this.setEnviarMens({
          tipo: e.mensajeT,
          mensaje: e.mensaje,
          tiempo: null,
        });
        console.log(e);
        return e;
      }
    },
    /**
     _______________________________________
    |          MÉTODO VER DOCUMENTO       */
    async ViewDocument() {
      if (this.objectSelected.data.file_ext == ".pdf") {
        this.parametroConfig = {
          fileLink: this.objectSelected.data.fileLink,
          fileDesc: this.objectSelected.data.file_desc,
          file_ext: this.objectSelected.data.file_ext,
        };
        this.compName = "LectorDocumentComp";
        this.estadoModalConfig = true;
      } else {
        await axios({
          url: `${this.objectSelected.data.fileLink}`,
          method: "GET",
          responseType: "blob",
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", this.objectSelected.data.file_desc);
          document.body.appendChild(fileLink);

          fileLink.click();
        });
      }
    },
    /**
     ______________________________________________
    |          MÉTODO PANTALLA COMPLETA          */
    ViewFullScreemVideo() {
      this.videoOptions.sources[0].src = `${this.objectSelected.data.fileLink}`;
      this.parametroConfig = {
        options: this.videoOptions,
      };
      this.compName = "LectorVideoComp";
      this.estadoModalConfig = true;
    },
    /**
     _________________________________________
    |          MÉTODO PAUSAR MEDIA          */
    PlayPauseMediaSelected() {
      if (this.objectSelected.data.type == "video") {
        let objectsVideo = this.objectSelected.getObjects()[1].getObjects();
        let elementVideo = objectsVideo[0].getElement();
        if (this.objectSelected.data.run == true) {
          elementVideo.pause();
          this.objectSelected.data.run = false;
          objectsVideo[0].visible = false;
          objectsVideo[1].visible = true;
          // if (typeof elementVideo.pause == "function") elementVideo.pause();
          // this.objectSelected.data.run = false;
          // objectsVideo[0].visible = false;
          // objectsVideo[1].visible = true;
        } else {
          elementVideo.play();
          this.objectSelected.data.run = true;
          objectsVideo[0].visible = true;
          objectsVideo[1].visible = false;
          // if (typeof elementVideo.play == "function") elementVideo.play();
          // this.objectSelected.data.run = true;
          // objectsVideo[0].visible = true;
          // objectsVideo[1].visible = false;
        }
        this.Render();
      } else if (this.objectSelected.data.type == "audio") {
        if (this.objectSelected.data.run == true) {
          // if (typeof this.objectSelected.data.element.pause == "function")
          this.objectSelected.data.element.pause();
          this.objectSelected.data.run = false;
        } else {
          // if (typeof this.objectSelected.data.element.play == "function")
          this.objectSelected.data.element.play();
          this.objectSelected.data.run = true;
        }
      }
    },
    /**
     __________________________________________
    |          MÉTODO RE PLAY MEDIA          */
    ReplayMediaSelected() {
      if (this.objectSelected.data.type == "video") {
        let objectsVideo = this.objectSelected.getObjects()[1].getObjects();
        let elementVideo = objectsVideo[0].getElement();
        elementVideo.pause();
        elementVideo.currentTime = "0";
        objectsVideo[0].visible = true;
        objectsVideo[1].visible = false;
        this.Render();
        elementVideo.play();
      } else if (this.objectSelected.data.type == "audio") {
        this.objectSelected.data.element.pause();
        this.objectSelected.data.element.currentTime = 0;
        this.objectSelected.data.element.play();
      }
      this.objectSelected.data.run = true;
    },
    /**
     _______________________________________
    |          MÉTODO STOP MEDIA          */
    StopMediaSelected() {
      if (this.objectSelected.data.type == "video") {
        let objectsVideo = this.objectSelected.getObjects()[1].getObjects();
        let elementVideo = objectsVideo[0].getElement();
        elementVideo.pause();
        elementVideo.currentTime = "0";
        objectsVideo[0].visible = false;
        objectsVideo[1].visible = true;
        this.Render();
      } else if (this.objectSelected.data.type == "audio") {
        this.objectSelected.data.element.pause();
        this.objectSelected.data.element.currentTime = 0;
      }
      this.objectSelected.data.run = false;
    },
    /**
     __________________________________________________
    |          MÉTODO RELLENO A DIAPOSITIVA          */
    RenderFill() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        this.objectSelected.set("fill", this.objectSelected.data.color);
      } else {
        this.objectSelected.setSelectionStyles(
          { fill: this.objectSelected.data.color },
          this.objectSelected.selectionStart,
          this.objectSelected.selectionEnd
        );
      }
      this.Render();
    },
    /**
     _____________________________________________________
    |          MÉTODO FONDO Y COLOR DEL TEXTO           */
    RenderBackGroundColorText() {
      if (
        this.objectSelected.data.backgroundColor.substring(0, 7) != "#FFFFFF" &&
        this.objectSelected.data.backgroundColor.substring(7, 9) == "00"
      ) {
        this.objectSelected.data.backgroundColor = `${this.objectSelected.data.backgroundColor.substring(
          0,
          7
        )}FF`;
        this.objectSelected.set(
          "backgroundColor",
          `${this.objectSelected.data.backgroundColor.substring(0, 7)}FF`
        );
      } else {
        this.objectSelected.set(
          "backgroundColor",
          this.objectSelected.data.backgroundColor.substring(0, 9)
        );
      }
      this.Render();
    },
    /**
     _________________________________________________________
    |          MÉTODO RENDERIZAR FUENTE Y TAMAÑO            */
    RenderFontSize() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        this.objectSelected.set("fontSize", this.fontSize);
        this.listDiapositivas[this.diapositivaSeleccionada].update = true;
      } else {
        this.objectSelected.setSelectionStyles(
          { fontSize: this.fontSize },
          this.objectSelected.selectionStart,
          this.objectSelected.selectionEnd
        );
        // this.listDiapositivas[this.diapositivaSeleccionada].update = true;
      }
      this.Render();
    },
    /**
     _____________________________________________________
    |          MÉTODO RENDERIZAR SOLO FUENTE            */
    RenderFontFamily() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        this.objectSelected.set("fontFamily", this.fontFamily);
      } else {
        this.objectSelected.setSelectionStyles(
          { fontFamily: this.fontFamily },
          this.objectSelected.selectionStart,
          this.objectSelected.selectionEnd
        );
      }
      this.Render();
    },
    /**
     ________________________________________________
    |          MÉTODO RENDERIZAR CANVAS            */
    Render() {
      this.canvas.renderAll();
      fabric.util.requestAnimFrame(this.Render);
    },
    /**
     _______________________________________________________
    |          MÉTODO CREACION DE TEXTO FABRIC            */
    CreateTextFabric(texto) {
      let text = new fabric.Textbox(`${texto}`, {
        width: 250,
        fill: "#000000",
        fontFamily: this.fontFamily,
        fontSize: this.fontSize,
        textAlign: "center",
        fontWeight: "normal",
        fontVariant: "lowercase",
        fontStyle: "normal",
        originX: "center",
        originY: "center",
        backgroundColor: "#FFFFFF00",
      });
      text.data = {
        type: "texto",
        color: "#000000",
        backgroundColor: "#FFFFFF00",
      };

      this.setStyleCorner(text);
      this.canvas.add(text);
      this.canvas.centerObject(text);
      this.canvas.setActiveObject(text);

      return text;
    },
    /**
     _______________________________________________________________________
    |          MÉTODO CAMBIAR FONDO DE MINIATURA EN TIEMPO REAL           */
    realTimeChange(color) {
      this.EventBackground(color);
    },
    /**
     _______________________________________________
    |          MÉTODO AGREGAR SIMBOLOS            */
    addSymbol(symbol) {
      const text = new fabric.Text(symbol, {
        left: this.canvas.width / 2,
        top: this.canvas.height / 2,
        fontSize: 20,
      });
      text.data = {
        type: "texto",
      };

      this.canvas.add(text);

      // let text = new fabric.Textbox(`${texto}`, {
      //   width: 250,
      //   fill: "#000000",
      //   fontFamily: this.fontFamily,
      //   fontSize: this.fontSize,
      //   textAlign: "center",
      //   fontWeight: "normal",
      //   fontVariant: "lowercase",
      //   fontStyle: "normal",
      //   originX: "center",
      //   originY: "center",
      //   backgroundColor: "#FFFFFF00",
      // });
      // text.data = {
      //   type: "texto",
      //   color: "#000000",
      //   backgroundColor: "#FFFFFF00",
      // };
      // this.setStyleCorner(text);
      // this.canvas.add(text);
      // this.canvas.centerObject(text);
      // this.canvas.setActiveObject(text);
      // text.selectAll();
      // // text.enterEditing();
      // // text.hiddenTextarea.focus();
      // return text;
    },
    /**
     __________________________________________________
    |          MÉTODO REMOVER SUPER INDICE           */
    removeSuper() {
      var active = this.canvas.getActiveObject();
      if (!active) return;
      active.setSelectionStyles({
        fontSize: undefined,
        deltaY: undefined,
      });
      this.canvas.requestRenderAll();
    },
    /**
     ___________________________________________________
    |          MÉTODO INSERTAR SUPER INDICE           */
    superScript() {
      var active = this.canvas.getActiveObject();
      if (!active) return;
      active.setSuperscript();
      this.canvas.requestRenderAll();
    },
    /**
     __________________________________________
    |          MÉTODO SUPER INDICE           */
    subScript() {
      var active = this.canvas.getActiveObject();
      if (!active) return;
      active.setSubscript();
      this.canvas.requestRenderAll();
    },
    /**
     ____________________________________________
    |          MÉTODO AÑADIR VIÑETAS           */
    addVinieta() {
      if (this.objectSelected) {
        const bullet = "\u2022 "; // Carácter de viñeta
        const selectedText = this.objectSelected.getSelectedText();

        if (selectedText) {
          const text = this.objectSelected.text;
          const newText = text.replace(selectedText, bullet + selectedText);
          this.objectSelected.set({ text: newText });
          this.canvas.renderAll();
        }
      }
    },
    /**
     ____________________________________________
    |          MÉTODO BORRAR OBJETOS           */
    BorrarObject() {
      if (this.objectSelected) {
        if (
          this.objectSelected.data.type == "audio" &&
          this.objectSelected.data.element
        ) {
          this.objectSelected.data.element.pause();
          this.objectSelected.data.element.currentTime = 0;
          this.objectSelected.data.run = false;
        } else if (
          this.objectSelected.data.type == "video" &&
          typeof this.objectSelected.getObjects == "function" &&
          this.objectSelected.getObjects()[1].getObjects()[0].getElement()
        ) {
          let elementVideo = this.objectSelected
            .getObjects()[1]
            .getObjects()[0]
            .getElement();
          if (JSON.stringify(elementVideo) != "{}" && elementVideo != null) {
            elementVideo.remove();
            elementVideo.currentTime = 0;
          } else if (this.objectSelected.data.element) {
            if (typeof this.objectSelected.data.element.pause == "function")
              this.objectSelected.data.element.pause();
            this.objectSelected.data.element.currentTime = 0;
          }
          this.objectSelected.data.run = false;
        }
        this.canvas.remove(this.objectSelected);
        this.objectSelected = null;
      }
    },
    /**
     ___________________________________________
    |          MÉTODO AGREGAR TEXTO           */
    AddTexto() {
      // alert('font size')
      this.listDiapositivas[this.diapositivaSeleccionada].update = true;
      this.fontSize = 20;
      this.CreateTextFabric("Agregar Texto");
      this.Render();
    },
    /**
     __________________________________________________
    |          MÉTODO FONDO DE DIAPOSITIVA           */
    EventBackground(valor) {
      this.listDiapositivas[this.diapositivaSeleccionada].backgroundCurrent =
        valor;
      let color = `${valor.substring(0, 9)}`;
      this.canvas.backgroundColor = color;
      this.Render();
      // if (this.cargando == false)
      this.listDiapositivas[this.diapositivaSeleccionada].update = true; //POSIBLE BUG
    },
    /**
     _____________________________________________________
    |          MÉTODO AJUSTAR MARCO DE LIENZO           */
    onWindowResize() {
      if (this.$refs.canvasKWSParent) {
        this.widthScene = this.$refs.canvasKWSParent.clientWidth - 25;
        this.heightScene = (this.widthScene * 55) / 100;

        if (this.canvas.width != this.widthScene) {
          var scaleMultiplier = this.widthScene / this.canvas.width;
          var objects = this.canvas.getObjects();
          for (var i in objects) {
            objects[i].scaleX = objects[i].scaleX * scaleMultiplier;
            objects[i].scaleY = objects[i].scaleY * scaleMultiplier;
            objects[i].left = objects[i].left * scaleMultiplier;
            objects[i].top = objects[i].top * scaleMultiplier;
            objects[i].setCoords();
          }
        }

        this.canvas.setDimensions({
          width: this.widthScene,
          height: this.heightScene,
        });
        this.canvas.setZoom(1);
        this.Render();
        this.canvas.calcOffset();
      }
    },
    /**
     ________________________________________________________
    |          MÉTODO CARGAR INSTANCIA DE FABRIC           */
    LoadFabric(finishLoad) {
      if (this.canvas) {
        this.canvas.dispose();
      }
      let img = document.createElement("img");
      img.src = this.deleteIcon;
      fabric.Object.prototype.cache = true;
      fabric.Object.prototype.touchAction = "none";
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "white";
      fabric.Object.prototype.cornerStrokeColor = "black";
      fabric.Object.prototype.cornerStyle = "circle";


      this.canvas = new fabric.Canvas("canvas", {
        selection: false,
        renderOnAddRemove: true,
        enableWebGL: false,
        enableRetinaScaling: true,
      });

      fabric.Image.prototype.quality = "high";

      this.onWindowResize();
      window.addEventListener("resize", this.onWindowResize);

      this.canvas.on("selection:created", (obj) => {
        this.objectSelected = obj.selected[0];
        if (this.objectSelected.data.type == "texto") {
          this.fontSize = this.objectSelected.fontSize;
          this.fontFamily = this.objectSelected.fontFamily;
        }
      });

      this.canvas.on("selection:updated", (obj) => {
        this.objectSelected = obj.selected[0];
        if (this.objectSelected.data.type == "texto") {
          this.fontSize = this.objectSelected.fontSize;
          this.fontFamily = this.objectSelected.fontFamily;
        }
      });

      this.canvas.on("selection:cleared", () => {
        const selectedObject = this.canvas.getActiveObject();
        if (!selectedObject) {
          this.canvasModifiedCallback();
        }
        this.objectSelected = null;
      });

      // Aplicar la caché a todos los objetos en el lienzo
      this.canvas.forEachObject((object) => {
        object.set({ cache: true });
      });

      this.canvas.on({
        "object:modified": this.canvasModifiedCallback,
        "text:changed": this.canvasModifiedCallback,
      });
      // Evento doble click
      fabric.util.addListener(this.canvas.upperCanvasEl, "dblclick", () => {
        if (this.objectSelected != null) {
          if (this.objectSelected.data.type == "documento") {
            this.ViewDocument();
            // } else if(this.objectSelected.data.type == 'video'){
            // this.ViewFullScreemVideo();
          }
        }
      });

      fabric.util.requestAnimFrame(this.Render);
      if (finishLoad == true) this.cargando = false;
    },
    /**
     _______________________________________________________________
    |          MÉTODO DETECTA EL ACTUALIZAR DIAPOSITIVA           */
    canvasModifiedCallback() {
      if (this.cargando == false && this.canvas) {
        this.listDiapositivas[this.diapositivaSeleccionada].update = true; //posible
      }
    },
    /**
     ___________________________________________
    |          MÉTODO BORDER CANVAS           */
    setStyleCorner(objeto) {
      if (objeto.data.type == "texto")
        objeto.setControlsVisibility({
          tl: false,
          mt: false,
          tr: false,
          bl: false,
          mb: false,
          br: false,
        });
      (objeto.cornerColor = "white"),
        (objeto.cornerStrokeColor = "black"),
        (objeto.cornerStyle = "circle");
    },
    /**
     __________________________________________________
    |          MÉTODO ACTUALIZAR TAG VIDEO           */
    ActualizarElementoVideo(obj) {
      let videoElem = this.SetUpVideo(obj.data.fileLink);
      videoElem.onloadeddata = () => {
        videoElem.width = videoElem.videoWidth;
        videoElem.height = videoElem.videoHeight;
        let group = obj.getObjects()[1];
        let video1 = group.getObjects()[0];
        group.objectCaching = false;
        video1.setElement(videoElem);
        video1.visible = false;
        obj.data.element = videoElem;
        obj.objectCaching = false;
        this.Render();
      };
    },
    /**
     __________________________________________________
    |          MÉTODO ACTUALIZAR TAG AUDIO           */
    ActualizarElementoAudio(obj) {
      //obj.data.fileLink

      let audioElem = this.SetUpAudio(obj.data.fileLink);
      obj.data.element = audioElem;
      this.Render();
    },
    /**
     _______________________________________
    |          MÉTODO SUBRAYADO           */
    underLineText() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        if (this.objectSelected.underline == true) {
          this.objectSelected.underline = false;
        } else {
          this.objectSelected.underline = true;
        }
      } else {
        if (
          this.objectSelected
            .getSelectionStyles()
            .find((charOption) => charOption.underline == true)
        ) {
          this.objectSelected.setSelectionStyles(
            { underline: false },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        } else {
          this.objectSelected.setSelectionStyles(
            { underline: true },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        }
      }
      this.Render();
    },
    /**
     ___________________________________________________
    |          MÉTODO CAMBIAR GROSOR FUENTE           */
    changeFontWeight() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        if (this.objectSelected.fontWeight == "bold") {
          this.objectSelected.fontWeight = "normal";
        } else {
          this.objectSelected.fontWeight = "bold";
        }
      } else {
        if (
          this.objectSelected
            .getSelectionStyles()
            .find((charOption) => charOption.fontWeight == "bold")
        ) {
          this.objectSelected.setSelectionStyles(
            { fontWeight: "normal" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        } else {
          this.objectSelected.setSelectionStyles(
            { fontWeight: "bold" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        }
      }
      this.Render();
    },
    /**
     ______________________________________________________
    |          MÉTODO CAMBIAR ESTILO DE FUENTE           */
    changeFontStyle() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        if (this.objectSelected.fontStyle == "italic") {
          this.objectSelected.fontStyle = "normal";
        } else {
          this.objectSelected.fontStyle = "italic";
        }
      } else {
        if (
          this.objectSelected
            .getSelectionStyles()
            .find((charOption) => charOption.fontStyle == "italic")
        ) {
          this.objectSelected.setSelectionStyles(
            { fontStyle: "normal" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        } else {
          this.objectSelected.setSelectionStyles(
            { fontStyle: "italic" },
            this.objectSelected.selectionStart,
            this.objectSelected.selectionEnd
          );
        }
      }
      this.Render();
    },
    /**
     ________________________________________________________
    |          MÉTODO CAMBIAR VARIEDAD DE FUENTE           */
    changeFontVariant() {
      if (
        this.objectSelected.selectionStart == this.objectSelected.selectionEnd
      ) {
        if (this.objectSelected.fontVariant == "lowercase") {
          this.objectSelected.text = this.objectSelected.text.toUpperCase();
          this.objectSelected.fontVariant = "uppercase";
        } else {
          this.objectSelected.text = this.objectSelected.text.toLowerCase();
          this.objectSelected.fontVariant = "lowercase";
        }
      } else {
        let selectedText = this.objectSelected.getSelectedText();
        if (selectedText) {
          let styles = this.objectSelected.getSelectionStyles();
          if (selectedText == selectedText.toUpperCase()) {
            this.objectSelected.insertChars(
              selectedText.toLowerCase(),
              styles.map((style) => {
                style.fontVariant = "lowercase";
                return style;
              }),
              this.objectSelected.selectionStart,
              this.objectSelected.selectionEnd
            );
          } else {
            this.objectSelected.insertChars(
              selectedText.toUpperCase(),
              styles.map((style) => {
                style.fontVariant = "lowercase";
                return style;
              }),
              this.objectSelected.selectionStart,
              this.objectSelected.selectionEnd
            );
          }
        }
      }
      this.Render();
    },
    /**
     _______________________________________________
    |          MÉTODO OBTENER NIVEL CK!           */
    async getNivel(id_pais) {
      try {
        let response = await axios.get(`/manager/nivelCkOne/pais/${id_pais}`);
        this.listNivel = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _______________________________________________
    |          MÉTODO CAMBIAR NIVEL CK!           */
    async EventNivel(filtro) {
      filtro.id_pais = this.dataSet.id_pais;
      this.messageVacio = false;
      this.listResourse = [];
      this.paginaActual = 1;
      try {
        filtro.id_area = "";
        const response = await axios.post("/manager/areaCkOne/pais/", filtro);

        this.listArea = response.data;

        if (this.listArea == "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No existen Áreas creadas para éste Nivel",
            tiempo: null,
          });
        }

        if (this.activateTemplate) {
          this.GetTemplate(this.filtro);
        }

        if (this.activateResource) {
          this.GetResource();
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
    /**
     ____________________________________________________
    |          MÉTODO EDITAR AL TRAER DIAPOS           */
    async EditItem(item) {
      this.GetDiapositivas(item.id_clase, item.diapositiva.id);
    },
    /**
     ___________________________________________________
    |          MÉTODO CARGAR TIPOS RECURSOS           */
    LoadMenu(filtro, name) {
      this.activateFiltroMenu = filtro;
      this.activateTemplate = false;
      this.activateDocument = false;
      this.activateResource = false;

      this.messageVacio = false;
      this.listResourse = [];
      this.paginaActual = 1;
      this.filtro = {
        search: "",
        id_tipo_recurso: "",
        id_acceso: "",
        id_nivel: "",
        id_area: "",
        id_pais: "",
        estado_template: true,
      };

      if (name == `template`) {
        this.activateTemplate = true;
        this.GetTemplate();
      }

      if (name == `resource`) {
        this.activateResource = true;
      }
    },
    /**
     ___________________________________________________
    |          MÉTODO CALCULAR ORDEN DIAPOS           */
    async calcularOrden() {
      if (this.parametros.evento == "agregar") {
        try {
          let resp = await axios.get(
            `/manager/contenido/contenidoCount/${this.dataSet.id_clase}`
          );
          this.orden = resp.data + 1;
        } catch (error) {
          console.log(error);
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      } else {
        this.orden = this.dataSet.orden;
      }
    },
    /**
     _____________________________________________
    |          MÉTODO VISOR DE DIAPOS           */
    visorDiapositivas() {
      this.compName = "visorContenido";
      this.estadoModalConfig = true;
      this.parametroConfig = {};
    },
    /**
     _______________________________________________
    |          MÉTODO CARGAR PLANTILLAS           */
    crearPlantilla() {
      this.parametroConfig = {
        evento: "agregar",
        id_nivel: this.parametros.item.id_nivel_grado,
        id_pais: this.parametros.item.id_pais,
      };
      this.compName = "TemplateFormComp";
      this.estadoModalConfig = true;

      // this.compName = "loadTemplate";
      // this.estadoModalConfig = true;
      // this.parametroConfig = this.parametros.item;
    },
    /**
     ______________________________________________
    |          MÉTODO EDITAR PLANTILLAS          */
    editarPlantilla(templateItem) {

      this.parametroConfig = {
        evento: "editar",
        item: templateItem,
        id_nivel: templateItem.id_nivel,
        id_pais: this.datoLogin.id_pais,
      };

      this.compName = "TemplateFormComp";
      this.estadoModalConfig = true;

    },
    /**
     ________________________________________________________________
    |          MÉTODO OBTENER PARAMETROS PARA PAGINACIÓN           */
    obtenerParametros(paginaActual, tamañoPorPagina, filtros) {
      let parametros = {};
      if (paginaActual) {
        parametros.paginaActual = paginaActual - 1;
      }
      if (tamañoPorPagina) {
        parametros.tamañoPorPagina = tamañoPorPagina;
      }
      if (filtros) {
        parametros = { ...parametros, ...filtros };
      }
      return parametros;
    },
    /**
     ______________________________________________
    |          MÉTODO CAMBIAR RECURSOS           */
    async changeResource() {
      this.messageVacio = false;
      this.listResourse = [];
      this.paginaActual = 1;
      await this.GetResource();
    },
    /**
     ______________________________________________
    |          MÉTODO OBTENER RECURSOS           */
    async GetResource() {
      if (this.listResourse.length > this.totalFilas) {
        return;
      }

      let patrametosListar = this.obtenerParametros(
        this.paginaActual,
        this.tamañoPorPagina,
        this.filtro
      );

      try {
        let response = await axios.post(
          `/manager/fileS3/gestorContenidoList/`,
          {
            filtro: patrametosListar,
          }
        );

        // eslint-disable-next-line no-unused-vars
        const { filas, totalPaginas, totalFilas } = response.data;
        if (response.data.message) {
          this.messageVacio = true;
        } else {
          this.messageVacio = false;
          this.totalFilas = totalFilas;
          this.listResourse = [...this.listResourse, ...filas];
        }
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     __________________________________________________
    |          MÉTODO CARGAR SOLO RECURSOS           */
    LoadResource() {
      let params = {
        id_clase: this.dataSet.id_clase,
        id_tema: this.dataSet.id_tema,
        id_pais: this.dataSet.id_pais,
      };
      this.compName = "loadResource";
      this.estadoModalConfig = true;
      this.parametroConfig = { evento: "add", items: params };
    },
    /**
     ________________________________________________________
    |          MÉTODO IMPORTAR DOC EN MINIATURAS           */
    LoadImportDoc() {
      if (this.listDiapositivas.length > 0 && this.listDiapositivas[this.diapositivaSeleccionada].update == false) {

        let params = {
          id_clase: this.dataSet.id_clase,
          id_tema: this.dataSet.id_tema,
          id_pais: this.dataSet.id_pais,
          id_nivel: this.dataSet.id_nivel_grado,
          id_grado: this.dataSet.id_grado_tema,
          id_area: this.dataSet.id_area,
        };

        this.compName = "loadImportDoc";
        this.estadoModalConfig = true;
        this.parametroConfig = { evento: "add", items: params };

      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe guardar o descartar los cambios efectuados en la lamina actual`,
          tiempo: null,
        });
      }
    },
    /**
     ____________________________________
    |          MÉTODO BUSCAR           */
    async Search(value, type) {
      clearTimeout(this.searchTimeController);
      this.searchTimeController = setTimeout(async () => {
        if (value) {
          // this.setEnviarMens({
          //   tipo: "W",
          //   mensaje: `Buscar: ${value}`,
          //   tiempo: null,
          // });
          if (type == "resource") {
            await this.changeResource(this.filtro);
          }

          if (type == "template") {
            await this.GetTemplate();
          }
        }
      }, 1600);
    },
    /**
     _______________________________________________
    |          MÉTODO LISTAR PLANTILLAS           */
    async GetTemplate() {

      try {
        let response = await axios.post(`/manager/contenido/getTemplateDiap/`, {
          filtro: this.filtro,
        });

        this.listTemplate = response.data;

        this.listTemplate.forEach((template) => {
          this.$set(this.showMenu, template.id, false);
        });
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     _________________________________________________________
    |          MÉTODO LISTAR PLANTILLAS AL INICIAR           */
    async GetTemplateDefault(filtro) {

      try {
        let { data } = await axios.post(`/manager/contenido/getTemplateDiap/`, {
          filtro: filtro,
        });

        if (data.length > 0) {

          this.listDiapositivas = data.map((templateItem, index) => {

            return {
              "update": false,
              "background": templateItem.background,
              "backgroundCurrent": "#0000AA",
              "canvas": templateItem.canvas,
              "miniatura": null,
              "uri": templateItem.uri,
              "orden_diapo": index + 1,
              "nombre_diapositiva": templateItem.nombre_template,
              "estado_diapositiva": true,
              "menu": false,
              "mostrar_a_estudiante": true,
              "editingTitle": false,
              "id": null
            }

          });

          this.listDiapositivas[this.diapositivaSeleccionada].update = false;
          await this.cargarDefaultDiap(this.listDiapositivas[this.diapositivaSeleccionada].canvas)
        } else {
          this.listDiapositivas = [{ ...this.baseDiapositiva }];
          this.listDiapositivas[this.diapositivaSeleccionada].update = false;
          this.LoadFabric(true);
        }

      } catch (error) {
        console.log(error);
      }
    },
    /**
     ________________________________________________
    |          MÉTODO ACTUALIZAR RECURSO           */
    async UpdateFile(items) {
      // let params = { "id_clase": this.dataSet.id_clase, "id_tema": this.dataSet.id_tema, "id_pais": this.dataSet.id_pais }
      this.compName = "loadResource";
      this.estadoModalConfig = true;
      this.parametroConfig = { evento: "edit", items };
    },
    /**
     ______________________________________________
    |          MÉTODO ELIMINAR RECURSO           */
    async DeleteFile(item) {
      const index = this.listResourse.findIndex(
        (resource) => resource.id == item.id
      );
      if (index !== -1) {
        this.listResourse.splice(index, 1);
      }
      try {
        await axios.delete(`/manager/fileS3/gestorContenido/${item.id}`);
        // this.listTemplate = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /**
     __________________________________________
    |          MÉTODO CARGAR PLANTILLA       */
    CargarTemplate(template) {
      this.color_fondo = template.background;
      this.listDiapositivas[this.diapositivaSeleccionada].background =
        template.background;
      this.listDiapositivas[this.diapositivaSeleccionada].backgroundCurrent =
        template.background;
      this.CargarScene(template);
    },
    /**
     ___________________________________________
    |          MÉTODO RELOAD COMPONENTE       */
    reloadComp(procedencia) {

      if (procedencia == "resource") {
        setTimeout(() => {
          this.changeResource(this.filtro);
        }, 1000);
      }
      if (procedencia == "template") {
        // this.listTemplate = [];
        this.timecomputed = new Date().getTime();

        // setTimeout(() => {

        this.GetTemplate(this.filtro);

        // }, 4000);
      }
    },
    /**
     ___________________________________________
    |          MÉTODO CERRAR COMPONENTE       */
    async closeComponent(dataImport) {
      this.estadoModalConfig = false;
      if (dataImport) {
        this.guardando = true;

        for (let i = 0; i < dataImport.length; i++) {
          await this.AddNewDiapositiva(null, null, dataImport[i]);
        }
        this.guardando = false;
      }
      // this.GetTemplate()
    },
    /**
     _____________________________________________
    |          MÉTODOS REF COPIAR Y PEGAR       */
    detectaTeclas(event) {
      if (event.ctrlKey && event.key === "c") {
        this.CopiarElementosCanvas();
      } else if (event.ctrlKey && event.key === "v") {
        this.PegarElementosCanvas();
      }
    },
    /**
     _____________________________________________
    |          MÉTODOS REF COPIAR Y PEGAR       */
    CopiarElementosCanvas() {
      const activeObject = this.canvas.getActiveObject();

      navigator.clipboard
        .readText()
        .then((texto) => {
          if (texto != "") {
            this.clipboard = false;
          }
        })
        .catch((err) => {
          console.error("Error al leer del portapapeles:", err);
        });

      // if (activeObject.type != 'image' && activeObject.type != 'textbox') {
      //   return false
      // }

      if (activeObject) {
        activeObject.clone((cloned) => {
          this.clipboard = cloned;
        });
      }
    },
    /**
     _____________________________________________
    |          MÉTODOS REF COPIAR Y PEGAR       */
    PegarElementosCanvas() {
      navigator.clipboard
        .readText()
        .then((texto) => {
          if (texto != "") {
            this.clipboard = false;

            navigator.clipboard
              .writeText("")
              .then(() => {
                console.log("Contenido del portapapeles borrado con éxito");
              })
              .catch((err) => {
                console.error(
                  "Error al borrar el contenido del portapapeles:",
                  err
                );
              });
          }
        })
        .catch((err) => {
          console.error("Error al leer del portapapeles:", err);
        });

      if (!this.clipboard) return;

      this.clipboard.clone((clonedObj) => {
        let type;
        switch (clonedObj.type) {
          case "image":
            (type = "imagen"),
              (clonedObj.data = { type: type, fileLink: clonedObj.src });
            break;

          case "textbox":
            (type = "texto"),
              (clonedObj.data = {
                type: type,
                color: clonedObj.fill,
                backgroundColor: clonedObj.backgroundColor,
              });
            break;

          case "group":
            (type = "video"),
              (clonedObj.data = {
                type: type,
                run: false,
                fileLink: clonedObj.src,
                elements: {},
              });
            break;

          default:
            break;
        }

        this.canvas.discardActiveObject();
        clonedObj.set({
          left: clonedObj.left + 10,
          top: clonedObj.top + 10,
          evented: true,
        });

        if (clonedObj.type === "activeSelection") {
          clonedObj.canvas = this.canvas;
          clonedObj.forEachObject((obj) => this.canvas.add(obj));
          clonedObj.setCoords();
        } else {
          this.canvas.add(clonedObj);
        }

        this.clipboard.top += 10;
        this.clipboard.left += 10;
        this.canvas.setActiveObject(clonedObj);
        this.canvas.requestRenderAll();
      });
    },
    /**
     ___________________________________________
    |          MÉTODOS OPCIONES DE MENU       */
    openMenuOptions(diapositiva) {
      if (!this.guardando) {
        this.listDiapositivas = this.listDiapositivas.map((d) => {
          d.menu = false;
          d.editingTitle = false;
          return d;
        });
        diapositiva.menu = true;
      }
    },
    /**
     ____________________________________________________
    |          MÉTODOS COLOCAR TITULO A LA DIAPO       */
    setTitleDiapositiva(diapositiva) {
      if (this.titleTemp) {
        diapositiva.orden_diapo = this.titleTemp;
        this.titleTemp = "";
        diapositiva.editingTitle = false;
        diapositiva.menu = false;
        diapositiva.update = true;
      }
    },
    /**
     _____________________________________________________
    |          MÉTODOS MOSTRAR DIAPO A ESTUDIANTE       */
    setMostrarAEstudiante(diapositiva) {
      diapositiva.mostrar_a_estudiante = !diapositiva.mostrar_a_estudiante;
      diapositiva.update = true;
    },
    /**
     __________________________________________________
    |          MÉTODOS DETENER VID AND AUD           */
    DetenerVideosYAudios() {
      if (this.canvas) {
        this.canvas
          .getObjects()
          .filter(
            (obj) =>
              obj.data && (obj.data.type == "audio" || obj.data.type == "video")
          )
          .forEach((obj) => {
            if (obj.data.type == "audio" && obj.data.element) {
              obj.data.element.pause();
              obj.data.element.currentTime = 0;
              obj.data.run = false;
            } else if (obj.data.type == "video") {
              // && obj.getObjects == "function" && obj.getObjects()[1].getObjects()[0].getElement()

              let elementVideo = obj
                .getObjects()[1]
                .getObjects()[0]
                .getElement();

              if (
                JSON.stringify(elementVideo) != "{}" &&
                elementVideo != null
              ) {
                elementVideo.remove();
                elementVideo.currentTime = 0;
              } else if (obj.data.element) {
                // try {
                obj.data.element.pause();
                obj.data.element.currentTime = 0;
                obj.getObjects()[1].getObjects()[0].visible = false;
                obj.getObjects()[1].getObjects()[1].visible = true;
                // } catch (error) {
                //   console.log(error);
                // }
              }
              obj.data.run = false;
            }
            this.Render();
          });
      }
    },

    ConfirmVolverShow() {
      if (this.listDiapositivas[this.diapositivaSeleccionada].update == true) {
        this.confirmVolver = true;
      } else {
        this.Close();
      }
    },

    ConfirmVolverClose() {
      this.Close();
    },

    ConfirmVolverTrue() {
      this.confirmVolver = false;
      this.ChangeDiapositiva(false, true, false, false);
    },

    ConfirmSaveShow() {
      this.confirmSave = true;
    },

    async ConfirmSaveClose() {
      this.listDiapositivas[this.diapositivaSeleccionada].update = false;

      this.listDiapositivas[this.diapositivaSeleccionada].backgroundCurrent =
        this.listDiapositivas[this.diapositivaSeleccionada].background;
      let indexCurrent = this.diapositivaSeleccionada;

      if (this.addNewDestino == true) {

        console.log('A');


        await this.LoadFabric(true);
      } else {




        console.log('q tre', this.listDiapositivas);
        console.log('B');
        console.log('id destino', this.diapositivaDestino);
        this.diapositivaSeleccionada = this.diapositivaDestino;
        this.listDiapositivas[this.diapositivaSeleccionada].update = false;
        this.listDiapositivas[this.diapositivaSeleccionada].backgroundCurrent = this.listDiapositivas[this.diapositivaSeleccionada].background;

        await this.CargarDiapositiva(this.listDiapositivas[this.diapositivaSeleccionada].canvas, false);

      }

      // if (
      //   !this.listDiapositivas[indexCurrent].id &&
      //   this.listDiapositivas.length > 1
      // ) {
      //   this.listDiapositivas.splice(indexCurrent, 1);
      //   if (this.diapositivaSeleccionada >= indexCurrent)
      //     this.diapositivaSeleccionada -= 1;
      // }
      // this.addNewDestino = false;
      // this.listDiapositivas[this.diapositivaSeleccionada].update = false;
      this.confirmSave = false;
    },

    async ConfirmSaveTrue() {
      this.confirmSave = false;

      if (this.addNewDestino == true) {
        await this.ChangeDiapositiva(null, false, false, false);
        let data = { ...this.baseDiapositiva };
        data.orden_diapo = `${this.listDiapositivas.length + 1}`;
        this.listDiapositivas.push(data);
        this.diapositivaSeleccionada = this.listDiapositivas.length - 1;
        this.color_fondo = data.backgroundCurrent;
        await this.LoadFabric();
      } else {
        this.ChangeDiapositiva(
          () => {
            this.diapositivaSeleccionada = this.diapositivaDestino;
            this.listDiapositivas[this.diapositivaSeleccionada].background =
              this.listDiapositivas[
                this.diapositivaSeleccionada
              ].backgroundCurrent;
            this.CargarDiapositiva(
              this.listDiapositivas[this.diapositivaSeleccionada].canvas
            );
          },
          false,
          false,
          false
        );
      }
      this.addNewDestino = false;
      this.confirmSave = false;
    },

    Close() {
      this.confirmVolver = false;
      this.DetenerVideosYAudios();
      this.$emit("close");
    },
    /**
     ____________________________________________
    |          MÉTODO LIMPIAR FORMULARIO       */
    LimpiarForm() {
      this.diapositivaSeleccionada = 0;
      this.listDiapositivas = [];
      this.objectSelected = null;
      this.activateTemplate = false;
      this.activateDocument = false;
      this.activateResource = false;
      // this.canvas.backgroundColor = "";

      this.filtro = {
        search: "",
        id_tipo_recurso: "",
        id_acceso: "",
        id_nivel: "",
        id_area: "",
        id_pais: "",
        estado_template: true,
      };
      this.guardando = false;
    },
  },
};
</script>

<style scoped>
.v-image[data-v-3abbc9ba] {
  filter: none;
}

.iconoUpdateBadge {
  cursor: pointer;
  z-index: 2;
  position: absolute !important;
  top: 0px;
  left: 0px;
}

.pointing {
  cursor: pointer;
}

.iconoEliminarBadge {
  cursor: pointer;
  z-index: 2;
  position: absolute !important;
  top: 0px;
  right: 0px;
}

.canvasKWSParent {
  position: relative;
  /* padding: 2em !important; */
  align-items: middle;
  justify-content: middle;
  /* background-color: lightgray; */
}

.progressCircular {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
}

.canvasKWST {
  box-shadow: 1px 1px 1px 1px #888888;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5em;
  filter: blur(0.5px) drop-shadow(3px 3px 18px rgba(0, 0, 0, 0.4));
}

.v-image {
  box-shadow: 0.5px 0.5px 1px 1px #888888;
  filter: blur(0.5px) drop-shadow(1px -5px 8px rgba(0, 0, 0, 0.2));
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.cardMiniatura {
  /* max-height: 150px; */
  overflow: hidden;
  text-align: center;
}

.cardMiniaturaSkeleton.v-skeleton-loader__image.v-skeleton-loader__bone {
  height: 120px !important;
}

.contMiniatura {
  /* float:left; */
  /*background:#CC6600;*/
  width: 100%;
}

.scroll {
  /*background-color: lightblue; */
  height: 260px;
  overflow-y: auto;
}

.ig-img {
  box-shadow: none !important;
  object-fit: cover;
  cursor: pointer;
}

.templeft {
  border: solid #ffbc00;
  border-style: dashed;
}

.zoomed {
  transform: scale(1.25);
  /* Cambia el valor 1.1 para ajustar el nivel de zoom */
  transition: transform 0.3s;
  /* Proporciona una animación suave */
}

.image-container {
  position: relative;
}

.button-container {
  position: absolute;
  top: 0px;
  /* right: 8px; */
  z-index: 99999;
  /* display: flex; */
  gap: 8px;
  /* Espacio entre los botones */
}
</style>
